import {
  Component,
  OnInit,
  ChangeDetectorRef,
  OnDestroy,
  ViewChild,
  inject,
  computed,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import {
  constrainNudgeRange,
  hasNudgeSplit,
  getNudgePeriod,
  hasVolvoNudgePeriods,
} from 'src/app/utils/nudge-period';
import { SessionService } from '../authentication/session.service';
import { TargetService } from './target.service';
import { SelectionService } from '../services/selection.service';
import { DateService } from '../services/date.service';
import { DarkmodeService } from '../services/darkmode.service';
import { SidenavService } from './sidenav.service';
import { PageTitleService } from '../services/pagetitle.service';
import { SeoService } from '../seo/seo.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { navigationLinks } from './navigationLinks';
import { ConfirmationComponent } from '../modals/confirmation/confirmation.component';
import { KeywordLimitComponent } from '../modals/keyword-limit/keyword-limit.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ShareAuditComponent } from '../website-audit/modals/share-audit/share-audit.component';
import {
  catchError,
  debounceTime,
  fromEvent,
  map,
  Observable,
  of,
  Subscription,
} from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { IntercomService } from '../services/intercom.service';
import { Title } from '@angular/platform-browser';
import { TimezoneService } from '../services/timezone.service';
import moment from 'moment-timezone';
import { AdsService } from '../ads/ads.service';
import { MeetingsPopupComponent } from '../seo/modals/meetings-popup/meetings-popup.component';
import { OverlayContainer } from '@angular/cdk/overlay';
import { MatSelect } from '@angular/material/select';
import { CoreTargetService } from '../core/services/target.service';
import { CoreCurrencyService } from '../core/services/currency.service';
import { NotificationService } from '../core/services/notification.service';
import { LocalStorageService } from '../core/services/local-storage.service';
import { CoreUserService } from '../core/services/user.service';
import { WebsiteAuditService } from '../website-audit/website-audit.service';
import { FullScreenPreviewService } from '../utils/full-screen-preview/full-screen-preview.service';
import { DateRangePickerComponent } from '../modals/date-range-picker/date-range-picker.component';
import { whiteLabelTarget } from '../utils/whiteLabel';
import {
  videoExplanationSrc,
  organicPDFLink,
  timezoneList,
} from '../utils/variables';
import { AppStateService } from '../store/app-state.service';

// declare const Intercom: any;

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css'],
  providers: [SessionService, PageTitleService],
})
export class SidenavComponent implements OnInit, OnDestroy {
  private appState = inject(AppStateService);
  public isShopify = computed(() => this.appState.isShopify());
  public learningMode = computed(() => this.appState.learningMode());
  public isShopifyAndLearning = computed(
    () => this.isShopify() && this.learningMode(),
  );
  public targetUrlSignal = computed(() => this.appState.targetUrl());

  clientList: any = [];
  clientListFiltered: any = [];

  liveClientList: any = [];
  liveClientListMAP: any = {};

  notLiveClientList: any = [];
  notLiveClientListMAP: any = {};

  workspacesClients: any = [];
  workspacesClientsMAP: any = {};

  darkMode = false;
  selectedTheme = 'light';
  selectedStore = 'Ochsnersport';
  sidenavOpen: boolean = false;
  url: string = '';
  loadNr = 0;
  header: any = '';
  headerBetaTxt: string = '';
  window: any;
  activeTarget = this.coreTargetService.getSelectedTarget('target');
  startDateMin = '';
  isOpened = false; // Default state of the sidenav
  mode = 'side';
  mobileQuery: MediaQueryList;
  seoOnly: any;

  allUserTargetPrivileges: any[];

  excludeEmailsFromVerifyPhone: string[] = ['master@behamics.com'];

  whiteLabelTarget = whiteLabelTarget;

  constructor(
    private authService: SessionService,
    public router: Router,
    public selectionService: SelectionService,
    public dateService: DateService,
    private targetList: TargetService,
    private sidenavService: SidenavService,
    private pageTitleService: PageTitleService,
    private seoService: SeoService,
    private changeDetectorRef: ChangeDetectorRef,
    private darkModeService: DarkmodeService,
    public dialog: MatDialog,
    media: MediaMatcher,
    private translate: TranslateService,
    private intercomService: IntercomService,
    private titleService: Title,
    private timezoneService: TimezoneService,
    private adsService: AdsService,
    private overlayContainer: OverlayContainer,
    private coreTargetService: CoreTargetService,
    private currencyService: CoreCurrencyService,
    private notificationService: NotificationService,
    private localStorageService: LocalStorageService,
    private coreUserService: CoreUserService,
    private websiteAuditService: WebsiteAuditService,
    private fullScreenPreviewService: FullScreenPreviewService,
  ) {
    if (this.whiteLabelTarget) {
      this.titleService.setTitle(
        this.whiteLabelTarget.description + ' Dashboard',
      );
    } else {
      this.titleService.setTitle('Behamics Dashboard');
    }

    this.mobileQuery = media.matchMedia('(max-width: 1200px)');
    this.updateLocalStorageDates();
  }

  sessionStorageService = this.localStorageService.withSession();

  showOverallSwitcher: boolean = false;
  overallSwitcher: boolean = false;

  showGonserOverallSwitcher: boolean = false;
  gonserOverallSwitcher: boolean = false;

  subs: Subscription = new Subscription();

  navigationLinks: any = [];

  subTriggerInvoices: boolean = false;
  subTriggerPerformance: boolean = false;
  subTriggerModelAutomation: boolean = false;
  subTriggerClientResults: boolean = false;
  subTriggerAutomationScript: boolean = false;
  subTriggerSEO: boolean = false;
  currentUserRole: any;
  subMasterTargetList: any;
  seoSubscription: any;
  seoSubscriptionList: any;

  confirmDialogRef: MatDialogRef<ConfirmationComponent>;
  keywordLimitDialogRef: MatDialogRef<KeywordLimitComponent>;
  gaStatus: boolean = false;
  gaStatusLoaded: boolean = false;

  keyWordData: any;
  selectedKeyWordData: any;

  // Filters
  selectedRangeValue = 'today';
  ranges = [
    {
      value: 'custom',
      viewValue: 'Custom',
      translateKey: 'words.custom',
    },
    {
      value: 'today',
      viewValue: 'Today',
      translateKey: 'words.today',
    },
    {
      value: 'yestarday',
      viewValue: 'Yesterday',
      translateKey: 'words.yestarday',
    },
    {
      value: 'thisweek',
      viewValue: 'This Week',
      translateKey: 'phrases.thisweek',
    },
    {
      value: 'last7days',
      viewValue: 'Last 7 days',
      translateKey: 'phrases.last7days',
    },
    {
      value: 'last30days',
      viewValue: 'Last 30 days',
      translateKey: 'phrases.last30days',
    },
    {
      value: 'thismonth',
      viewValue: 'This Month',
      translateKey: 'phrases.thismonth',
    },
    {
      value: 'lastmonth',
      viewValue: 'Last Month',
      translateKey: 'phrases.lastmonth',
    },
    {
      value: 'thisyear',
      viewValue: 'This Year',
      translateKey: 'phrases.thisyear',
    },
  ];

  startDate = new Date();
  endDate = new Date();
  maxDate = new Date();
  endMaxDate = new Date();
  minDate = new Date();
  rate = 'hourly';
  isLimitedView = false;
  demoAccount = false;
  selectedTab = 0;
  showNavWithTabs = false;
  hasOwnTabs = false;
  pagesWithTabs = [
    { url: '/recording', tabs: true, hasOwnTabs: true },
    { url: '/diagnostic', tabs: true, hasOwnTabs: true },
    { url: '/agents', tabs: true, hasOwnTabs: true },
    { url: '/seo/pages', tabs: false },
    { url: '/seo/projects', tabs: false },
    { url: '/seo/backlinks', tabs: true, hasOwnTabs: true },
    { url: '/seo/keywords', tabs: true, hasOwnTabs: true },
    { url: '/seo/automations', tabs: true, hasOwnTabs: true },
    { url: '/seo/ai-analysis', tabs: false },
    { url: '/seo/backlink-prediction', tabs: true, hasOwnTabs: true },
    { url: '/seo/positions', tabs: false },
    { url: '/seo/technicals', tabs: false },
    { url: '/seo/on-page', tabs: false },
    { url: '/seo/social', tabs: false },
    { url: '/detailed/trace-error', tabs: false },
    { url: '/merchandising', tabs: true, hasOwnTabs: true },
    { url: '/master-ai-experiments', tabs: true },
    { url: '/client-results/overall', tabs: true },
    { url: '/merchandising/product-details', tabs: false },
    { url: '/master-preview', tabs: true, hasOwnTabs: true },
    { url: '/master-performance-detailed', tabs: true },
    { url: '/statistics-configurations', tabs: false },
    { url: '/merchandising/category-details', tabs: false },
    { url: '/signal', tabs: true, hasOwnTabs: true },
    { url: '/signals', tabs: true, hasOwnTabs: true },
    { url: '/signals/monday/oauth/callback', tabs: true, hasOwnTabs: true },
    { url: '/integrations/klaviyo', tabs: true, hasOwnTabs: true },
    { url: '/ads', tabs: true, hasOwnTabs: true },
    { url: '/ads/projects', tabs: false },
    { url: '/ads/ai-audit', tabs: false },
    { url: '/ads/integrations', tabs: false },
    { url: '/ads/competitors', tabs: true, hasOwnTabs: true },
    { url: '/invoices', tabs: true, hasOwnTabs: true },
    { url: '/model-automation', tabs: true, hasOwnTabs: true },
    { url: '/notetaking', tabs: true, hasOwnTabs: true },
    { url: '/website-audit', tabs: true, hasOwnTabs: true },
    { url: '/nudgeGPT', tabs: true, hasOwnTabs: true },
  ];

  showCompareDatesContainer: boolean = false;
  compareStartDate = new Date(new Date().setHours(0, 0, 0));
  compareEndDate = new Date(new Date().setHours(new Date().getHours(), 0, 0));
  compareMinDate = new Date();
  compareMaxDate = new Date();
  isCompareDatesActive: boolean = false;

  seoProjects: any = [];
  seoProjectsFiltered: any = [];
  selectedSeoProject: any;
  selectedSeoProjectURL: string;
  seoStillLoadingBlock: boolean = true;
  noProjectSelected: boolean = true;

  seoOnlyLinks: boolean = false;
  adsOnlyLinks: boolean = false;
  backlinkFreelancerOnlyLinks: boolean = false;

  navigationLinksFiltered: any = [];

  allKeywords: any;

  isLoading: boolean = true;

  disableSeoLinks: boolean = false;

  seoSubscriptionsList = [];

  savedLang: string = '';

  is_organic_under_maintenance: boolean = false;

  selectedTimezone: string = '';

  isGSCConnected: boolean = false;

  showKeywordsLeft: boolean = false;
  keywordsUsedPercentage: any = 0;
  keywordsLeft: any = '';

  timezoneList: any = timezoneList;

  hideTimezoneSelection: boolean = false;

  selectedCompetitor: any = null;

  isTargetWithOverallSwitcher: boolean = false;

  selectedAdsProject: any;
  selectedAdsProjectStatus: {
    isLoading: boolean;
    percentage: number;
  } = {
    isLoading: false,
    percentage: 0,
  };
  selectedAdsProjectDomain: any = '';
  adsProjects: any = [];
  adsProjectsFiltered: any = [];

  isMasterRole: boolean = false;

  is7DaysFreeTrial: boolean = false;
  daysLeft: number = 0;

  currentUser: any = this.coreUserService.getUserInfo();
  nonBehamicsUser: any = false;
  hideSecondaryMenuLinks: any = false;

  favoriteClientsSidenavMAP: any = [];

  hoveredStoreId: string = '';
  trackByClient = (_: number, c: { _id: string }) => c._id;

  clientSearchValue: string = '';

  invoiceStatus: any = null;
  invoiceFilterStatus: string = 'all';

  public demoAccountForTarget: boolean = false;
  private hideForTheseEmails: string[] = [
    'philipp.spreer@elaboratum.de',
    'george@quicksmithconsulting.com',
    'testermell@testermelltestermell',
  ];

  public isBehamicsUser: boolean = false;
  public nudgeLiteToggle: boolean = false;
  public isTargetNudgelite: boolean = false;

  public websiteAuditProject: any;
  public websiteAuditProjects: any = [];
  public websiteAuditProjectsFiltered: any = [];
  public selectedWebsiteAuditProjectDomain: string | null = null;
  public selectedWebsiteAuditProjectId: string | null = null;
  public selectedWebsiteAuditTask: any = null;
  public currentPage: string = '';
  public showExplanationVideoBool: boolean = false;

  public userInfo: any = {
    name: '',
    email: '',
  };

  compareFn = (o1: string, o2: string) => o1 === o2;
  languages = [
    { code: 'en', label: 'words.english' },
    { code: 'fr', label: 'words.french' },
    { code: 'de', label: 'words.german' },
    { code: 'it', label: 'words.italian' },
    { code: 'ja', label: 'words.japanese' },
  ];

  currentLang: string = 'en';

  public websiteAuditDownloading: boolean = false;
  public showWebsiteAuditDownloadButton: boolean = false;
  public showWebsiteAuditDownloadButtonEmails: string[] = [
    'aleksandra.trajkov@behamics.com',
  ];

  ngOnInit() {
    const email: string = this.localStorageService.get('email') || '';
    const name: string = this.localStorageService.get('name') || '';

    this.showWebsiteAuditDownloadButton =
      this.showWebsiteAuditDownloadButtonEmails.includes(email);

    this.userInfo = {
      name,
      email,
    };

    this.localStorageService.set('kpiSymbol', "#'€'");

    this.isMasterRole = this.localStorageService.get('role') === 'master';
    this.savedLang = this.localStorageService.get('language') || 'en';
    this.currentLang = this.translate.currentLang || this.savedLang;

    this.subs.add(
      this.translate.onLangChange.subscribe((event) => {
        this.currentLang = event.lang || 'en';
        this.savedLang = event.lang || 'en';
      }),
    );

    this.getFavoriteTargets();
    this.isDaylightSavingTime();

    this.setSelectedTimezone();

    this.selectedTimezone = this.timezoneService.getTimezone();

    // Deepclone array to not update the one from navigationLinks file
    this.navigationLinks = JSON.parse(JSON.stringify(navigationLinks));

    // gonser overall witcher
    this.gonserOverallSwitcher =
      this.localStorageService.get('gonserOverallSwitcher') || false;

    this.isBehamicsUser = email?.endsWith('@behamics.com') ? true : false;

    this.overallSwitcher =
      this.localStorageService.get('nudgeOverallSwitcher') || false;

    this.updateSidenavLinks();
    this.checkDemoAccount();

    this.is7DaysFreeTrial =
      this.localStorageService.get('is_7_days_free_trial') || false;

    // this.toggleSidenavSize();
    // Theme Mode Checker
    if (typeof this.localStorageService.get('darkMode') == 'boolean') {
      this.darkMode = this.localStorageService.get('darkMode') || false;
      if (this.darkMode) {
        this.selectedTheme = 'dark';
        document.body.classList.add('dark-theme');
      } else {
        this.selectedTheme = 'light';
        document.body.classList.remove('dark-theme');
      }
    } else {
      const deviceMode = window.matchMedia('(prefers-color-scheme: dark)');
      if (deviceMode.matches) {
        this.darkMode = true;
        this.selectedTheme = 'dark';
        document.body.classList.add('dark-theme');
        this.localStorageService.set('darkMode', true);
      }
    }

    this.subs.add(
      fromEvent(window, 'resize')
        .pipe(debounceTime(200))
        .subscribe(() => this.onResize()),
    );

    this.subs.add(
      this.selectionService.currentMessage.subscribe((message) => {
        this.selectedStore =
          message || this.coreTargetService.getSelectedTarget('name');

        // This subscriber runs before the dashboard subscribers on target/filter changes.
        if (this.hasNudgePeriodSplit) {
          this.updateLocalStorageDates();
          if (this.isCompareDatesActive) this.compareDates();
        }

        if (!this.isCompareDatesActive) {
          // set compare dates a period previous
          const previousPeriod = this.getPreviousPeriod(
            this.startDate,
            this.endDate,
          );
          this.compareStartDate = previousPeriod.startDate;
          this.compareEndDate = previousPeriod.endDate;
        }

        if (typeof message === 'string') {
          const target = this.coreTargetService.getSelectedTarget('target');
          this.showGonserOverallSwitcher =
            (this.router.url.includes('/merchandising') &&
              target?.includes('gonser')) ||
            false;

          this.showOverallSwitcher =
            (this.isTargetWithOverallSwitcher &&
              !this.showGonserOverallSwitcher &&
              this.router.url.includes('/master-preview')) ||
            false;

          this.nonBehamicsUser =
            !email?.endsWith('@behamics.com') || email == 'dummy@behamics.com';
          const targetCondition = target == 'behamicsSample';

          this.hideSecondaryMenuLinks = this.nonBehamicsUser && targetCondition;

          if (this.isShopify()) {
            this.hideSecondaryMenuLinks = true;
          }
        }
      }),
    );

    this.subs.add(
      this.sidenavService.getIsGSCConnected().subscribe((res) => {
        this.isGSCConnected = res;
      }),
    );

    this.getGSCIntegrationStatus();

    this.sidenavService.statusUpdateObservable.subscribe((status) => {
      if (status >= 100) {
        this.seoStillLoadingBlock = false;
        this.openProductTour();
      }
    });

    this.seoService.value$.subscribe((newValue) => {
      this.keyWordData = newValue;

      // Set the first value of keyWordData if available
      if (this.keyWordData && this.keyWordData.length > 0) {
        const comp = this.keyWordData.find((keyword: any) => {
          return keyword?.domain === this.selectedCompetitor?.domain;
        });
        if (comp) {
          this.selectedKeyWordData = comp;
          this.seoService.updateSelectedObject(comp);
        } else {
          this.selectedKeyWordData = this.keyWordData[0];
          this.seoService.updateSelectedObject(this.keyWordData[0]);
        }
      } else {
        this.seoService.updateSelectedObject(undefined);
      }
    });

    this.seoService.allValue$.subscribe((newValue) => {
      if (newValue) {
        this.allKeywords = newValue;
      }
    });

    this.subs.add(
      this.websiteAuditService.getAuditTasks().subscribe((tasks) => {
        this.websiteAuditProjects = tasks;
      }),
    );
    this.subs.add(
      this.websiteAuditService.getSelectedAuditTask().subscribe((task: any) => {
        if (task) {
          this.selectedWebsiteAuditTask = task;
          this.selectedWebsiteAuditProjectDomain = task?.domain;
          // The audit list is keyed by the parent/canonical taskId, but the
          // detail response returns the latest run's taskId. Bind the selector
          // to whichever id actually exists in the options (falling back to the
          // parent id) so the input reflects the selected audit's domain.
          const ids = [task?.taskId, task?.parentTaskId].filter(Boolean);
          const match = (this.websiteAuditProjects || []).find((p: any) =>
            ids.includes(p?.taskId),
          );
          this.selectedWebsiteAuditProjectId =
            match?.taskId || task?.parentTaskId || task?.taskId;
        }
      }),
    );

    this.subs.add(
      this.pageTitleService.title.subscribe((val: string) => {
        if (val) {
          if (
            this.localStorageService.get('save_last_tab') == null &&
            sessionStorage.getItem('save_temporary_title') !== val
          ) {
            this.sidenavService.updateActiveTabIndex(0);
            this.selectedTab = 0;
          }
          this.localStorageService.remove('save_last_tab');

          sessionStorage.setItem('save_temporary_title', val);
        }

        if (val?.includes('beta version')) {
          this.headerBetaTxt = '(Beta Version)';
          this.header = val.split('beta version')[0].trim();
        } else {
          this.headerBetaTxt = '';

          this.header =
            this.getTranslatedText(val, 'sidenav_links').pipe(
              catchError(() => of(val)),
            ) || '';
        }

        let falseIndex = 0;
        for (let i = 0; i < this.pagesWithTabs.length; i++) {
          let url = this.router.url.split('?')[0];
          if (url == this.pagesWithTabs[i].url) {
            this.showNavWithTabs = this.pagesWithTabs[i].tabs;
            this.hasOwnTabs = this.pagesWithTabs[i].hasOwnTabs ? true : false;
            break;
          } else {
            falseIndex++;
          }
        }
        if (falseIndex == this.pagesWithTabs.length) {
          this.showNavWithTabs = false;
          this.hasOwnTabs = false;
        }

        if (
          this.router.url.includes('/seo/') &&
          val &&
          !this.router.url.includes('/seo/billing')
        )
          this.getSeoProjectsFunc();
      }),
    );
    this.subs.add(
      this.sidenavService.getActiveTabIndex().subscribe((index) => {
        this.selectedTab = index;

        if (this.isCompareDatesActive) {
          this.isCompareDatesActive = false;
          this.compareDates();
        }

        this.showCompareDatesContainerFunc();

        const url = this.router.url?.split('?')[0];
        this.currentPage = videoExplanationSrc[url]?.[index]?.label || '';
        this.checkShowExplanationVideo();
      }),
    );

    const today = new Date();
    const etoday = new Date();

    const reuseDates = this.localStorageService.get('reuseDates');
    if (reuseDates) {
      const stringStartDate: any =
        this.localStorageService.get('startDate') || '';
      const stringEndDate: any = this.localStorageService.get('endDate') || '';

      const localStorageStartDate: any = stringStartDate?.split('@')[0];
      const localStorageEndDate: any = stringEndDate?.split('@')[0];

      this.startDate = new Date(localStorageStartDate);
      this.endDate = new Date(localStorageEndDate);

      this.minDate = this.startDate;
      this.maxDate = this.endDate;

      this.selectedRangeValue =
        this.localStorageService.get('rangeValue') || '';
    } else {
      today.setHours(0, 0, 0);
      this.startDate = today;
      etoday.setHours(etoday.getHours(), 59, 59);
      this.endDate = etoday;
      this.localStorageService.set('rangeValue', this.selectedRangeValue);
    }
    this.localStorageService.remove('reuseDates');

    // set compare dates a period previous
    const previousPeriod = this.getPreviousPeriod(this.startDate, this.endDate);
    this.compareStartDate = previousPeriod.startDate;
    this.compareEndDate = previousPeriod.endDate;

    this.updateLocalStorageDates();

    if (
      this.router.url == '/invoices/list' ||
      this.router.url == '/invoices/configuration'
    ) {
      this.subTriggerInvoices = true;
    }
    if (this.router.url.includes('/model-automation')) {
      this.subTriggerModelAutomation = true;
    }
    if (
      this.router.url.includes('/seo/') &&
      !this.router.url.includes('/seo/billing')
    ) {
      this.subTriggerSEO = true;
      for (let i = 0; i < this.navigationLinks.length; i++) {
        if (this.navigationLinks[i].title === 'Organic') {
          this.navigationLinks[i].active = true;
        }
      }
    }
    if (this.router.url.includes('/ads/')) {
      this.subTriggerSEO = false;
      for (let i = 0; i < this.navigationLinks.length; i++) {
        if (this.navigationLinks[i].title === 'Ad Copilot') {
          this.navigationLinks[i].active = true;
        }
      }

      this.sidenavService.getAdsProjectsFunc();
    }
    if (this.router.url != '/seo/content') {
      sessionStorage.removeItem('draftActive');
      sessionStorage.removeItem('task_Active');
      sessionStorage.removeItem('keyword_opened_editor_Active');
    }
    if (this.router.url == '/client-results/overall') {
      this.subTriggerClientResults = true;
    }
    if (
      this.router.url == '/script-automation/configuration' ||
      this.router.url == '/script-automation/debug'
    ) {
      this.subTriggerAutomationScript = true;
    }

    this.currentUserRole = this.localStorageService.get('role');

    if (
      this.router.url.includes('/seo/') &&
      this.is_organic_under_maintenance
    ) {
      this.showNavWithTabs = false;
      this.hasOwnTabs = false;
      this.router.navigate(['organic-maintenance']);
      return;
    }
    if (
      this.router.url.includes('/seo/') &&
      !this.router.url.includes('/seo/billing')
    ) {
      this.openProductTour();
    }

    if (
      this.router.url.includes('/notetaking') &&
      this.selectedRangeValue == 'today'
    ) {
      this.selectedRangeValue = 'last30days';
      this.rangeChanged(null);
    }

    this.subs.add(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.checkShowExplanationVideo();
          this.showCompareDatesContainerFunc();
          const target = this.coreTargetService.getSelectedTarget('target');
          (this.router.url.includes('/merchandising') &&
            target?.includes('gonser')) ||
            false;

          this.showOverallSwitcher =
            (this.isTargetWithOverallSwitcher &&
              !this.showGonserOverallSwitcher &&
              this.router.url.includes('/master-preview')) ||
            false;

          const contentContainer =
            document.querySelector('.mat-sidenav-content') || this.window;
          contentContainer.scrollTo(0, 0);

          this.updateLocalStorageDates();

          this.updateIntercom();

          if (
            this.router.url.includes('/seo/') &&
            this.is_organic_under_maintenance
          ) {
            this.showNavWithTabs = false;
            this.hasOwnTabs = false;
            this.router.navigate(['organic-maintenance']);
            return;
          }
          if (this.router.url.includes('/seo/')) {
            this.openProductTour();
          }

          if (
            this.localStorageService.get('organic_signup_premium') &&
            this.localStorageService.get('seoSubscription') != 'Premium' &&
            email != 'master@behamics.com'
          ) {
            this.router.navigate(['/seo/billing']);
          }

          if (
            this.freeTrialExpiredBool &&
            !this.router.url.includes('/seo/getting-started')
          ) {
            this.router.navigate(['/seo/getting-started']);
            setTimeout(() => {
              this.freeTrialExpired();
            }, 10);
          }

          if (this.router.url.includes('/ads/')) {
            this.sidenavService.getAdsProjectsFunc();
          }

          if (
            this.router.url.includes('/notetaking') &&
            this.selectedRangeValue == 'today'
          ) {
            this.selectedRangeValue = 'last30days';
            this.rangeChanged(null);
          }
        }
      }),
    );

    if (this.currentUserRole == 'master') {
      if (sessionStorage.getItem('target') && sessionStorage.getItem('name')) {
        this.coreTargetService.setSelectedTarget(
          'target',
          sessionStorage.getItem('target') || '',
        );
        this.coreTargetService.setSelectedTarget(
          'name',
          sessionStorage.getItem('name') || '',
        );

        this.selectedStore =
          this.coreTargetService.getSelectedTarget('name') || '';
      } else {
        if (this.whiteLabelTarget) {
          this.selectedStore = this.whiteLabelTarget?.description;
          this.coreTargetService.setSelectedTarget(
            'target',
            this.whiteLabelTarget?.target,
          );
          this.coreTargetService.setSelectedTarget(
            'name',
            this.whiteLabelTarget?.description,
          );
          this.sessionStorageService.set('region', 'west-eu');
        } else {
          this.selectedStore = 'Ochsnersport';
          this.coreTargetService.setSelectedTarget('target', 'ochsnersport');
          this.coreTargetService.setSelectedTarget('name', 'Ochsnersport');

          this.sessionStorageService.set('region', 'west-eu');
        }
      }

      this.subs.add(
        this.targetList.getTargetList().subscribe((list) => {
          this.clientList = list;
          this.clientListFiltered = list;

          this.localStorageService.set('shopId_list', list);

          this.constructClientSelector('');

          let filteredList: any[];
          filteredList = this.clientList.filter(
            (o: any) => o.description == this.selectedStore,
          );

          this.gaStatus = filteredList[0]?.ga4;
          this.gaStatusLoaded = true;

          this.isTargetWithOverallSwitcher =
            filteredList[0].overallView || false;

          this.showOverallSwitcher =
            (this.isTargetWithOverallSwitcher &&
              !this.showGonserOverallSwitcher &&
              this.router.url.includes('/master-preview')) ||
            false;

          const gcr = filteredList?.[0]?.value || 0;
          this.sidenavService.globalControlRate.set(gcr);

          if (location.href.includes('?target')) {
            var url_string = window.location.href;
            var url = new URL(url_string);

            this.selectedStore = url.searchParams.get('target') || '';
            this.startDate = new Date(url.searchParams.get('startDate') || '');
            this.endDate = new Date(url.searchParams.get('endDate') || '');

            this.coreTargetService.setSelectedTarget(
              'target',
              this.selectedStore,
            );
            this.updateLocalStorageDates();
          }

          // Nudge Lite Detector
          this.localStorageService.set(
            'nudgeLite',
            filteredList[0].value == 0.01,
          );

          this.isTargetNudgelite = filteredList[0].value == 0.01;
          this.nudgeLiteToggle = filteredList[0].value == 0.01;

          if (this.nudgeLiteToggle) {
            this.nudgeLiteToggleTheme = 'on';
          } else {
            this.nudgeLiteToggleTheme = 'off';
          }

          this.currencyService.setSelectedCurrency(filteredList[0].currency);

          try {
            this.appState.learningMode.set(
              filteredList[0]?.learningPhase || false,
            );
            this.appState.autoActivate.set(
              filteredList[0]?.autoActivate || false,
            );
            this.appState.behamicsDeactivated.set(
              filteredList[0]?.deactivated || false,
            );
            this.appState.isShopifyTarget.set(
              filteredList[0]?.isShopifyTarget || false,
            );
          } catch (e) {}

          try {
            this.appState.targetUrl.set(filteredList[0]?.url || '');
          } catch (e) {}
        }),
      );
    }

    this.activeTarget = this.coreTargetService.getSelectedTarget('target');
    setTimeout(() => {
      this.updateCurrencySymbol();
    }, 400);

    if (email == 'master@behamics.com') {
      this.localStorageService.set('seoSubscription', 'Premium');
    } else {
      if (this.localStorageService.get('seoSubscriptionObj')) {
        if (
          this.localStorageService.get('seoSubscriptionObj') == '"Premium"' ||
          this.localStorageService.get('seoSubscriptionObj') == '"Freemium"'
        ) {
          if (
            this.localStorageService.get('seoSubscriptionObj') == '"Premium"'
          ) {
            this.localStorageService.set('seoSubscription', 'Premium');
          }
          if (
            this.localStorageService.get('seoSubscriptionObj') == '"Freemium"'
          ) {
            this.localStorageService.set('seoSubscription', 'Freemium');
          }
        } else {
          const seoObj: any =
            this.localStorageService.get('seoSubscriptionObj') || '[]';
          const filtered = seoObj?.filter(
            (item: any) => item.shopID == this.activeTarget,
          );
          if (filtered.length > 0) {
            this.localStorageService.set(
              'seoSubscription',
              filtered[0].seoSubscription ?? 'Freemium',
            );
          } else {
            this.localStorageService.set('seoSubscription', 'Freemium');
          }
        }
        this.seoSubscription = this.localStorageService.get('seoSubscription');
      }
    }

    if (
      this.localStorageService.get('user-verify-phone') &&
      !this.excludeEmailsFromVerifyPhone.includes(email)
    ) {
      setTimeout(() => {
        document.body.classList.remove('organic_loading');
      }, 10);
      this.router.navigate(['verify-phone']);
    } else if (
      this.localStorageService.get('organic_signup_premium') &&
      this.localStorageService.get('seoSubscription') != 'Premium' &&
      this.localStorageService.get('email') != 'master@behamics.com'
    ) {
      setTimeout(() => {
        document.body.classList.remove('organic_loading');
      }, 10);
      this.router.navigate(['/seo/billing']);
    }

    this.updateUserRoles();

    try {
      this.sidenavService.getMinDate().subscribe((date: string) => {
        this.startDateMin = date;
      });
    } catch (e) {
      console.log(e);
    }

    this.subs.add(
      this.sidenavService.getAdsProjectStatus().subscribe((project: any) => {
        this.selectedAdsProjectStatus = project;

        if (
          this.router.url.includes('/ads/') &&
          !this.router.url.includes('/ads/projects') &&
          !this.selectedAdsProjectStatus.isLoading &&
          this.selectedAdsProjectStatus.percentage < 100
        ) {
          this.router.navigate(['/ads/getting-started']);
        }
      }),
    );
    this.subs.add(
      this.sidenavService.getAdsProjects().subscribe((projects: any) => {
        this.adsProjects = projects || [];
        this.adsProjectsFiltered = [...projects];

        let selectedProject = this.adsProjects.filter(
          (p: any) => this.selectedAdsProjectDomain === p['domain'],
        )?.[0];

        if (!selectedProject) {
          selectedProject = this.adsProjects[0];
        }
        this.sidenavService.setAdsProject(selectedProject);
      }),
    );
    this.subs.add(
      this.sidenavService.getAdsProject().subscribe((project: any) => {
        this.selectedAdsProject = project;
        this.selectedAdsProjectDomain =
          this.selectedAdsProject?.['domain'] || '';

        if (project) {
          if (project.statusBar == 100) {
            this.sidenavService.setAdsProjectStatus({
              isLoading: false,
              percentage: 100,
            });
          } else {
            this.sidenavService.setAdsProjectStatus({
              isLoading: true,
              percentage: project.statusBar,
            });

            this.adsService
              .getProjectStatus({ customerId: project?.project })
              .subscribe((res: any) => {
                this.sidenavService.setAdsProjectStatus({
                  isLoading: false,
                  percentage: res?.status?.statusBar,
                });
              });
          }
        } else if (this.adsProjects?.length == 0 && !project) {
          this.sidenavService.setAdsProjectStatus({
            isLoading: false,
            percentage: 100,
          });
        }
      }),
    );

    this.subs.add(
      this.sidenavService.getInvoiceTotals().subscribe((data: any) => {
        this.invoiceStatus = data;
      }),
    );
    this.subs.add(
      this.sidenavService
        .getInvoiceTotalsFilterStatus()
        .subscribe((data: any) => {
          this.invoiceFilterStatus = data;
        }),
    );
  }
  ngOnDestroy(): void {
    document.body.style.opacity = '1';
    this.subs.unsubscribe();
  }
  @ViewChild('clientSelect') clientSelect: MatSelect;
  ngAfterViewInit() {
    try {
      this.subs.add(
        this.clientSelect?.openedChange.subscribe((opened) => {
          if (!opened) {
            if (!this.workspacesClientsMAP[this.selectedStore]) {
              this.showWorkspaces = false;
            }
            if (!this.notLiveClientListMAP[this.selectedStore]) {
              this.showNonLive = false;
            }

            if (this.clientListFiltered.length == 0) {
              this.clientSearchValue = '';
              this.constructClientSelector('');
            }
          }
        }),
      );
    } catch (e) {
      console.log(e);
    }
  }

  private checkDemoAccount() {
    const email: string = this.localStorageService.get('email') || '';
    if (this.hideForTheseEmails.includes(email)) {
      this.demoAccountForTarget = true;
    } else {
      this.demoAccountForTarget = false;
    }
  }

  public invoiceFilterStatusChanged(status: string): void {
    const sts = this.invoiceFilterStatus == status ? 'all' : status;

    this.invoiceFilterStatus = sts;
    this.sidenavService.setInvoiceTotalsFilterStatus(sts);
  }

  private getFavoriteTargets(): void {
    this.targetList.getFavoriteTargets().subscribe({
      next: (res: any) => {
        this.favoriteClientsSidenavMAP = res || [];
      },
      error: () => {
        this.favoriteClientsSidenavMAP = [];
      },
    });
  }

  private stringSort(a: string, b: string): number {
    try {
      return a.toLowerCase().localeCompare(b.toLowerCase());
    } catch (e) {
      console.log(e);
      return 0;
    }
  }

  private constructClientSelector(search: string): void {
    try {
      // filtered clients
      this.clientListFiltered = this.clientList.filter((target: any) => {
        const normalize = (text: string) =>
          text
            ?.toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/ä/g, 'a')
            .replace(/ö/g, 'o')
            .replace(/ü/g, 'u')
            .replace(/ß/g, 'ss');

        const normalizedSearch = normalize(search);
        const description = normalize(target['description']);
        const clientTarget = normalize(target['target']);

        return (
          description?.startsWith(normalizedSearch) ||
          clientTarget?.startsWith(normalizedSearch)
        );
      });
      // live clients
      this.liveClientList = this.clientListFiltered.filter(
        (o: any) =>
          o.live == true &&
          !o.description?.toLowerCase().startsWith('workspace'),
      );
      this.liveClientList = this.liveClientList.map((client: any) => {
        return {
          ...client,
          isFavorite: this.favoriteClientsSidenavMAP.includes(client.target),
        };
      });
      this.liveClientList = this.liveClientList.sort((a: any, b: any) => {
        if (a.isFavorite && !b.isFavorite) return -1;
        if (!a.isFavorite && b.isFavorite) return 1;

        return this.stringSort(a.description, b.description);
      });
      this.liveClientListMAP = this.liveClientList.reduce(
        (acc: any, client: any) => {
          acc[client.description] = client;
          return acc;
        },
        {},
      );

      // workspaces
      this.workspacesClients = this.clientListFiltered.filter((o: any) =>
        o.description?.toLowerCase().startsWith('workspace'),
      );
      this.workspacesClients = this.workspacesClients.sort((a: any, b: any) => {
        return this.stringSort(a.description, b.description);
      });
      this.workspacesClientsMAP = this.workspacesClients.reduce(
        (acc: any, client: any) => {
          acc[client.description] = client;
          return acc;
        },
        {},
      );

      // not live clients
      this.notLiveClientList = this.clientListFiltered.filter(
        (o: any) =>
          o.live == false &&
          !o.description?.toLowerCase().startsWith('workspace'),
      );
      this.notLiveClientList = this.notLiveClientList.sort((a: any, b: any) =>
        this.stringSort(a.description, b.description),
      );
      this.notLiveClientListMAP = this.notLiveClientList.reduce(
        (acc: any, client: any) => {
          acc[client.description] = client;
          return acc;
        },
        {},
      );

      if (!this.workspacesClientsMAP[this.selectedStore]) {
        this.showWorkspaces = false;
      } else {
        this.showWorkspaces = true;
      }
      if (!this.notLiveClientListMAP[this.selectedStore]) {
        this.showNonLive = false;
      } else {
        this.showNonLive = true;
      }
    } catch (e) {
      console.log(e);
    }
  }

  toggleFavorite(client: any) {
    if (client.isFavorite) {
      this.favoriteClientsSidenavMAP = this.favoriteClientsSidenavMAP.filter(
        (c: any) => c !== client.target,
      );

      this.targetList.deleteTargetToFavorites(client.target).subscribe({
        next: () => {
          this.notificationService.info(
            'Client has been removed from favorites!',
          );
        },
        error: () => {
          this.notificationService.error('Something went wrong!');
        },
      });
    } else {
      this.favoriteClientsSidenavMAP.push(client.target);

      this.targetList.addTargetToFavorites(client.target).subscribe({
        next: () => {
          this.notificationService.info('Client has been added to favorites!');
        },
        error: () => {
          this.notificationService.error('Something went wrong!');
        },
      });
    }
    client.isFavorite = !client.isFavorite;

    this.liveClientList = this.liveClientList.sort((a: any, b: any) => {
      if (a.isFavorite && !b.isFavorite) return -1;
      if (!a.isFavorite && b.isFavorite) return 1;

      return this.stringSort(a.description, b.description);
    });
  }

  getTranslatedText(text: string, type: string = 'words'): Observable<string> {
    if (!text || text?.length === 0) {
      return of(text);
    }

    return this.translate.get(`${type}.${text}`).pipe(
      map((translated: string) =>
        translated === `${type}.${text}` ? text : translated,
      ),
      catchError(() => of(text)),
    );
  }

  private getGSCIntegrationStatus(): void {
    this.subs.add(
      this.seoService.integrationsGSCIntegrated().subscribe({
        next: (res) => {
          this.isGSCConnected = (res && res.integrated) || false;
          this.sidenavService.setIsGSCConnected(this.isGSCConnected);
        },
        error: (err) => {
          console.log(err);
        },
      }),
    );
  }

  onSelectKeywordData(selectedValue: any) {
    this.selectedKeyWordData = selectedValue;

    if (selectedValue) {
      this.seoService.updateSelectedObject(selectedValue);
    }
  }

  updateIntercom(): void {
    if (window.Intercom) {
      window.Intercom('update');
    }
  }

  changeGa4Status() {
    let header;
    let content;

    if (this.gaStatus) {
      header = 'Disconnect Google Analytics';
      content =
        'Are you sure you want to disable event transfer to Google Analytics?';
    } else {
      header = 'Connect Google Analytics';
      content =
        'Are you sure you want to connect and transfer events to Google Analytics?';
    }

    this.confirmDialogRef = this.dialog.open(ConfirmationComponent, {
      width: '430px',
      data: {
        header: header,
        content: content,
      },
    });

    this.confirmDialogRef.afterClosed().subscribe((result) => {
      if (result == 1) {
        this.targetList
          .updateGa4Status(
            this.coreTargetService.getSelectedTarget('target'),
            !this.gaStatus,
          )
          .subscribe((res: any) => {
            this.gaStatus = res.ga4;
            if (res.ga4) {
              this.notificationService.info(
                'Google Analytics has been connected!',
              );
            } else {
              this.notificationService.info(
                'Google Analytics has been disconnected!',
              );
            }
          });
      }
    });
  }
  updateSidenavLinks() {
    this.isLoading = true;
    let role: string[] = this.localStorageService.get('privileges') || [];

    if (role.length === 0) {
      this.authService.logout();
    }

    let seoLinksIndex = 0;
    this.navigationLinksFiltered = [];

    let adsLinksIndex = 0;
    let backlinkFreelancerLinksIndex = 0;

    for (let i = 0; i < role.length; i++) {
      if (role[i].includes('seo') || role[i] == 'userPermissions') {
        seoLinksIndex += 1;
      }

      if (role[i].includes('ads') || role[i] == 'userPermissions') {
        adsLinksIndex += 1;
      }

      if (
        role[i].includes('backlink_freelancer') ||
        role[i] == 'userPermissions'
      ) {
        backlinkFreelancerLinksIndex += 1;
      }
    }

    if (seoLinksIndex == role.length) {
      this.seoOnly = true;
    } else {
      this.seoOnly = false;
    }

    for (let i = 0; i < this.navigationLinks.length; i++) {
      if (
        role.includes(this.navigationLinks[i].privilege) ||
        (this.navigationLinks[i].title == 'Organic' && seoLinksIndex > 0)
      ) {
        let link = { ...this.navigationLinks[i] };
        // check for children
        if (this.navigationLinks[i]?.children?.length > 0) {
          let children = [];
          for (let j = 0; j < this.navigationLinks[i].children.length; j++) {
            if (
              role.includes(this.navigationLinks[i].children[j].privilege) &&
              !this.navigationLinks[i].children[j].hideFromView
            ) {
              children.push(this.navigationLinks[i].children[j]);
            }
          }

          if (!this.navigationLinks[i]?.hideFromView) {
            link.children = [...children];
          }
        }

        // add to filtered list
        if (!this.navigationLinks[i]?.hideFromView) {
          if (this.navigationLinks[i]?.children?.length > 0) {
            if (link?.children?.length > 0) {
              this.navigationLinksFiltered.push(link);
            } else {
              this.navigationLinksFiltered.push({
                title: this.navigationLinks[i]?.title,
                icon: {
                  src: this.navigationLinks[i]?.icon?.src,
                  inlineStyle: this.navigationLinks[i]?.icon.inlineStyle,
                },
                active: false,
                children: [],
                callback: () => {
                  this.closeParentTrigger();
                },
                disabled: true,
              });
            }
          } else {
            const isDashboardPage =
              this.navigationLinks[i]?.title == 'Dashboard';

            this.navigationLinksFiltered.push({
              ...link,
              // disable when its shopify and learning mode
              ...(this.isShopifyAndLearning() && !isDashboardPage
                ? {
                    shopifyDisabled: true,
                    routerLink: null,
                    active: false,
                  }
                : {}),
            });
          }
        }
      } else if (
        !this.navigationLinks[i]?.hideFromView &&
        !this.navigationLinks[i]?.hideIfNoPrivileges
      ) {
        this.navigationLinksFiltered.push({
          title: this.navigationLinks[i]?.title,
          icon: {
            src: this.navigationLinks[i]?.icon?.src,
            inlineStyle: this.navigationLinks[i]?.icon.inlineStyle,
          },
          active: false,
          children: [],
          callback: () => {
            this.closeParentTrigger();
          },
          disabled: true,
        });
      }
    }

    if (seoLinksIndex === role.length) {
      let seoLinks = this.navigationLinksFiltered.filter(
        (link: any) => link.title === 'Organic',
      )?.[0];
      this.navigationLinksFiltered = [...seoLinks?.children];
      this.seoOnlyLinks = true;
    } else if (adsLinksIndex === role.length) {
      let adsLinks = this.navigationLinksFiltered.filter(
        (link: any) => link.title === 'Ad Copilot',
      )?.[0];
      this.navigationLinksFiltered = [...adsLinks?.children];
      this.adsOnlyLinks = true;
    } else if (backlinkFreelancerLinksIndex === role.length) {
      let backlinkFreelancerLinks = this.navigationLinksFiltered.filter(
        (link: any) => link.title === 'Backlink Freelancer',
      )?.[0];
      this.navigationLinksFiltered = [...backlinkFreelancerLinks?.children];
      this.backlinkFreelancerOnlyLinks = true;
    } else {
      this.navigationLinksFiltered = this.navigationLinksFiltered.filter(
        (link: any) => link.title !== 'Backlink Freelancer',
      );
      this.navigationLinksFiltered.sort((a: any, b: any) => {
        if (!a?.disabled && b?.disabled) {
          return -1;
        }
        return 0;
      });
      this.adsOnlyLinks = false;
      this.seoOnlyLinks = false;
      this.backlinkFreelancerOnlyLinks = false;

      if (this.router.url.includes('/ads/')) {
        this.subTriggerSEO = false;
        for (let i = 0; i < this.navigationLinks.length; i++) {
          if (this.navigationLinks[i].title === 'Ad Copilot') {
            this.navigationLinks[i].active = true;
          }
        }
      }
    }

    this.isLoading = false;
    this.adaptNavigationListHeight();
  }

  navigationLinksCallback(title: string) {
    if (title == 'Organic' && this.is_organic_under_maintenance) {
      this.showNavWithTabs = false;
      this.hasOwnTabs = false;
      this.router.navigate(['organic-maintenance']);
      return;
    }

    if (title == 'Organic') {
      this.parentSEOClick();
    } else if (title == 'Ad Copilot') {
      this.parentAdsClick();
    } else if (title == 'Backlink Freelancer') {
      this.parentBacklinkFreelancerClick();
    } else {
      this.closeParentTrigger();
    }
    if (this.mobileQuery.matches) {
      let selectedNavigationLink = this.navigationLinksFiltered.find(
        (obj: any) => {
          return obj.title === title;
        },
      );
      if (
        selectedNavigationLink &&
        selectedNavigationLink?.children?.length > 0
      ) {
        this.isOpened = true;
      }
    }
  }

  ngAfterContentChecked() {
    this.changeDetectorRef?.detectChanges();
  }
  seoProjectsFired = false;
  getSeoProjectsFunc(byPassFirstLoad = false) {
    if (this.seoProjectsFired && !byPassFirstLoad) return;

    if (
      !byPassFirstLoad &&
      !this.localStorageService.get('organic_onboarding_redirect') &&
      this.seoOnly
    ) {
      document.body.classList.add('organic_loading');
    }

    this.seoProjectsFired = true;
    this.subs.add(
      this.seoService.getProjects().subscribe({
        next: (response) => {
          document.body.classList.remove('organic_loading');

          if (this.is_organic_under_maintenance) return;

          if (response && response.length > 0) {
            this.disableSeoLinks = false;
          } else {
            this.disableSeoLinks = true;
          }
          if (response) {
            if (response.length === 0) {
              if (
                this.localStorageService.get('organic_signup_premium') &&
                this.localStorageService.get('seoSubscription') != 'Premium' &&
                this.localStorageService.get('email') != 'master@behamics.com'
              ) {
                this.router.navigate(['/seo/billing']);
              } else {
                if (
                  this.localStorageService.get('organic_onboarding_redirect')
                ) {
                  this.router.navigate(['/seo/projects']);
                } else {
                  this.localStorageService.set(
                    'organic_onboarding_redirect',
                    true,
                  );
                  this.router.navigate(['/organic_onboarding']);
                }
              }
            }
            this.seoProjects = response;

            this.seoProjects = this.seoProjects.sort((a: any, b: any) => {
              if (a?.domain < b?.domain) {
                return -1;
              }
              if (a?.domain > b?.domain) {
                return 1;
              }
              return 0;
            });

            this.seoProjectsFiltered = [...this.seoProjects];

            let parsedSessionProject: any;
            try {
              if (
                sessionStorage.getItem('selectedProject') &&
                sessionStorage.getItem('selectedProject')?.trim() !==
                  'undefined'
              ) {
                parsedSessionProject = JSON.parse(
                  sessionStorage.getItem('selectedProject') || '{}',
                );
              } else {
                parsedSessionProject = {};
              }
            } catch (e) {
              console.log(e);
            }

            const pagesSeoUrl = sessionStorage.getItem('pages_seo_url');

            if (pagesSeoUrl) {
              this.selectedSeoProject = this.seoProjects.find((p: any) =>
                pagesSeoUrl.includes(p['domain']),
              );

              sessionStorage.removeItem('pages_seo_url');
            } else if (Object.keys(parsedSessionProject).length > 0) {
              this.selectedSeoProject = this.seoProjects.find((p: any) =>
                parsedSessionProject['domain']?.includes(p['domain']),
              );

              if (!this.selectedSeoProject) {
                this.selectedSeoProject = this.seoProjects[0];
              }
            } else {
              this.selectedSeoProject = this.seoProjects[0];
            }

            this.selectedSeoProjectURL = this.selectedSeoProject?.url;

            if (this.selectedSeoProject) {
              this.sidenavService.setSeoProject(this.selectedSeoProject);
            } else {
              this.sidenavService.setSeoProject('');
            }

            this.subs.add(
              this.sidenavService.childData$().subscribe((data: any) => {
                if (data.selectedCompetitor) {
                  this.selectedCompetitor = data;
                }
                if (data.url) {
                  this.selectedSeoProjectURL = data.url;
                } else if (this.selectedSeoProject) {
                  this.selectedSeoProjectURL = this.selectedSeoProject.url;
                }
                this.seoProjectChanged();
              }),
            );
          } else {
            this.seoProjects = [];
            this.sidenavService.setSeoProject('');
          }
        },
        error: (error) => {
          document.body.classList.remove('organic_loading');
          console.error(error);
          this.seoProjects = [];
          this.seoProjectsFiltered = [];
          this.sidenavService.setSeoProject('');
        },
      }),
    );
  }

  searchProjects(event: any) {
    const value = event?.target?.value;

    try {
      this.seoProjectsFiltered = this.seoProjects.filter((project: any) => {
        const lowerCaseValue = value.toLowerCase();

        return (
          project.domain.toLowerCase().includes(lowerCaseValue) ||
          project.url.toLowerCase().includes(lowerCaseValue)
        );
      });
    } catch (e) {
      console.log(e);
    }
  }

  searchTargets(): void {
    try {
      this.constructClientSelector(this.clientSearchValue);
    } catch (e) {
      console.log(e);
    }
  }

  seoLinkLoadingChecker(parent: any, child: any) {
    if (parent?.title === 'Organic' || parent['disable_on_zero_projects']) {
      if (
        child?.title === 'AI Audit' ||
        child?.title === 'Dashboard' ||
        child?.title === 'Content' ||
        child?.title === 'Positions' ||
        child?.title === 'Keywords' ||
        child?.title === 'AI Analysis' ||
        child?.title === 'Backlink Prediction' ||
        child?.title === 'Backlinks' ||
        child?.title === 'Rank Tracker' ||
        child?.title === 'Competitors' ||
        parent?.['disable_on_zero_projects']
      ) {
        return this.seoStillLoadingBlock;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  redirectToScripts() {
    this.router.navigate(['/seo/scripts']);
  }
  seoProjectChanged() {
    this.selectedSeoProject = this.seoProjects.filter(
      (p: any) => this.selectedSeoProjectURL === p['url'],
    )[0];

    this.seoService.getKeywordData(this.selectedSeoProject?.domain).subscribe(
      (res) => {
        if (res.total_left === null) {
          this.showKeywordsLeft = false;
          return;
        }

        this.keywordsLeft = res.total_left;
        this.keywordsUsedPercentage = res.used_percent;
        if (this.keywordsLeft >= 0) {
          this.showKeywordsLeft = true;
        }
      },
      (err) => {
        this.showKeywordsLeft = false;
        console.log(err);
      },
    );

    // If there is no project selected return
    if (!this.selectedSeoProject) {
      this.noProjectSelected = true;
      return;
    }
    this.noProjectSelected = false;

    this.subs.add(
      this.seoService
        .getStatusOfProject({ domain: this.selectedSeoProject?.domain?.trim() })
        .subscribe({
          next: (res) => {
            if (res.averageStatusBar >= 100) {
              this.seoStillLoadingBlock = false;
            } else {
              this.seoStillLoadingBlock = true;
              if (
                this.localStorageService.get('organic_signup_premium') &&
                this.localStorageService.get('seoSubscription') != 'Premium' &&
                this.localStorageService.get('email') != 'master@behamics.com'
              ) {
                this.router.navigate(['/seo/billing']);
              } else if (!this.router.url.includes('/seo/projects')) {
                this.router.navigateByUrl('/seo/getting-started');
              }
            }
            this.sidenavService.setSeoProject(this.selectedSeoProject);
          },
          error: (err) => {
            console.log(err);
          },
        }),
    );
  }

  adsProjectChanged() {
    this.selectedAdsProject = this.adsProjects.filter(
      (p: any) => this.selectedAdsProjectDomain === p['domain'],
    )?.[0];
    this.sidenavService.setAdsProject(this.selectedAdsProject);
  }

  getDomainFromUrl(url: string): string | null {
    try {
      const normalized = url.startsWith('http') ? url : `https://${url}`;

      const { hostname } = new URL(normalized);
      return hostname.replace(/^www\./, '');
    } catch {
      return null;
    }
  }

  websiteAuditProjectChanged() {
    this.websiteAuditProject = this.websiteAuditProjects.find(
      (p: any) => this.selectedWebsiteAuditProjectId === p['taskId'],
    );

    this.websiteAuditService.updateAuditTasksLoading(true);
    this.subs.add(
      this.websiteAuditService
        .getAuditTask(this.websiteAuditProject?.taskId)
        .subscribe({
          next: (res) => {
            const domainFromUrl = this.getDomainFromUrl(res?.url);
            if (!domainFromUrl) {
              this.websiteAuditService.updateAuditTasksLoading(false);
              this.websiteAuditService.updateSelectedAuditTask(res);
              return;
            }

            this.subs.add(
              this.seoService
                .getStatusOfProject({ domain: domainFromUrl })
                .subscribe({
                  next: (organicProgress: any) => {
                    this.websiteAuditService.updateAuditTasksLoading(false);
                    const crawlStatus =
                      organicProgress?.progresses?.[0]?.crawl_status || '';

                    this.websiteAuditService.updateSelectedAuditTask({
                      ...res,
                      organicProgress: {
                        progress: organicProgress?.averageStatusBar,
                        status: crawlStatus,
                      },
                    });
                  },
                  error: (err) => {
                    this.websiteAuditService.updateAuditTasksLoading(false);
                    this.websiteAuditService.updateSelectedAuditTask({
                      ...res,
                      organicProgress: {
                        progress: 0,
                        status: 'failed',
                      },
                    });
                  },
                }),
            );
          },
          error: (err) => {
            this.websiteAuditService.updateAuditTasksLoading(false);
            this.notificationService.error(err?.error?.message);
          },
        }),
    );
  }

  searchAdsProjects(event: any) {
    const value = event?.target?.value;

    try {
      this.adsProjectsFiltered = this.adsProjects.filter((project: any) => {
        const lowerCaseValue = value.toLowerCase();
        return (
          project.domain.toLowerCase().includes(lowerCaseValue) ||
          project.project.toLowerCase().includes(lowerCaseValue)
        );
      });
    } catch (e) {
      console.log(e);
    }
  }

  searchWebsiteAuditProjects(event: any) {
    const value = (event?.target?.value || '').toLowerCase();

    try {
      this.websiteAuditProjectsFiltered = this.websiteAuditProjects
        .filter((project: any) => {
          const domain = (project?.domain || '').toLowerCase();
          const url = (project?.url || '').toLowerCase();
          const name = (project?.name || '').toLowerCase();
          return !(
            domain.includes(value) ||
            url.includes(value) ||
            name.includes(value)
          );
        })
        .map((p: any) => p?.domain);
    } catch (e) {
      console.log(e);
    }
  }

  checkRoleGuard(page: any) {
    const role: string[] = this.localStorageService.get('privileges') || [];
    if (role?.length > 0) {
      if (role.findIndex((priv) => priv == page) < 0) {
        return false;
      } else {
        return true;
      }
    } else {
      this.authService.logout();
      return false;
    }
  }

  themeChanged() {
    if (this.selectedTheme == 'dark') {
      this.darkMode = true;
      document.body.classList.add('dark-theme');
      this.localStorageService.set('darkMode', true);
    } else {
      this.darkMode = false;
      document.body.classList.remove('dark-theme');
      this.localStorageService.set('darkMode', false);
    }
    this.darkModeService.updateDarkMode(this.darkMode);
  }

  switchThemeMode(event: any) {
    if (event.checked) {
      this.darkMode = true;
      document.body.classList.add('dark-theme');
      this.localStorageService.set('darkMode', true);
    } else {
      this.darkMode = false;
      document.body.classList.remove('dark-theme');
      this.localStorageService.set('darkMode', false);
    }

    // this.selectionService.selectedStore({ themeMode: 'changed' });
    this.darkModeService.updateDarkMode(event.checked);
  }

  updateUserRoles() {
    const email: any = this.localStorageService.get('email');

    if (
      this.localStorageService.get('user-verify-phone') &&
      !this.excludeEmailsFromVerifyPhone.includes(email)
    ) {
      setTimeout(() => {
        document.body.classList.remove('organic_loading');
      }, 10);
      this.router.navigate(['verify-phone']);
      return;
    }

    document.body.style.opacity = '0';
    this.subs.add(
      this.targetList.getCurrentUserRoles(email).subscribe({
        next: (res) => {
          if (res?.role) this.localStorageService.set('role', res?.role);

          this.currentUser = res || null;

          this.currentUserRole = res?.role;

          this.checkDemoAccount();

          document.body.style.opacity = '1';
          this.is7DaysFreeTrial = res.is_7_days_free_trial || false;
          const todayDate = new Date();
          const creationDate = new Date(res.creationDate);
          const diffTime = todayDate.getTime() - creationDate.getTime();
          const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
          this.daysLeft = Math.max(0, 7 - diffDays);

          if (this.daysLeft <= 0) {
            if (this.is7DaysFreeTrial) {
              this.router.navigate(['/seo/getting-started']);
              this.freeTrialExpired();
            }
          }

          this.localStorageService.set('customerId', res['customerId']);

          if (res['ads_roles'] && res['ads_roles']?.length > 0) {
            this.localStorageService.set('user_ads_roles', res['ads_roles']);
          }

          this.subMasterTargetList = res.shopID;

          this.seoSubscriptionList = res?.seoSubscription || [];
          this.seoSubscription = '';

          if (res?.signup_premium) {
            this.localStorageService.set('organic_signup_premium', true);
          }

          if (this.currentUserRole == 'master') {
            this.seoSubscription = 'Premium';
          } else {
            const target = this.coreTargetService.getSelectedTarget('target');
            const seoSub =
              this.seoSubscriptionList.find((sub: any) => {
                return sub.shopID == target;
              })?.seoSubscription || 'Freemium';

            this.seoSubscription = seoSub || 'Freemium';
          }
          this.localStorageService.set('seoSubscription', this.seoSubscription);

          if (this.currentUserRole == 'sub-master') {
            const tmpTarget =
              this.coreTargetService.getSelectedTarget('target');
            if (
              tmpTarget &&
              this.subMasterTargetList.find(
                (list: any) => list.target == tmpTarget,
              )
            ) {
              const storageTarget = this.subMasterTargetList.find(
                (list: any) => list.target == tmpTarget,
              );

              this.selectedStore = storageTarget.description;

              this.coreTargetService.setSelectedTarget(
                'target',
                storageTarget.target,
              );
              this.coreTargetService.setSelectedTarget(
                'name',
                storageTarget.description,
              );

              this.isTargetWithOverallSwitcher =
                storageTarget.overallView || false;

              this.currencyService.setSelectedCurrency(storageTarget.currency);

              const gcr = storageTarget?.value || 0;
              this.sidenavService.globalControlRate.set(gcr);

              try {
                this.appState.targetUrl.set(storageTarget?.url || '');
              } catch (e) {}
            } else {
              const firstTarget = this.subMasterTargetList[0];

              try {
                this.appState.targetUrl.set(firstTarget?.url || '');
              } catch (e) {}

              this.selectedStore = firstTarget.description;
              this.coreTargetService.setSelectedTarget(
                'target',
                firstTarget.target,
              );
              this.coreTargetService.setSelectedTarget(
                'name',
                firstTarget.description,
              );

              this.isTargetWithOverallSwitcher =
                firstTarget.overallView || false;

              this.currencyService.setSelectedCurrency(firstTarget.currency);

              const gcr = firstTarget?.value || 0;
              this.sidenavService.globalControlRate.set(gcr);
            }

            this.clientList = this.subMasterTargetList;

            this.showOverallSwitcher =
              (this.isTargetWithOverallSwitcher &&
                !this.showGonserOverallSwitcher &&
                this.router.url.includes('/master-preview')) ||
              false;

            this.localStorageService.set('shopId_list', this.clientList);
          }

          const organicSub = res?.seoSubscription?.find((sub: any) => {
            return (
              sub.shopID == this.coreTargetService.getSelectedTarget('target')
            );
          });

          if (res?.stripeConfig && organicSub?.seoSubscription == 'Freemium') {
            this.router.navigate(['organic-billing']);
            return;
          }

          // if user is not premium, doesn't have stripeconfig show full screen billing
          if (this.seoSubscription != 'Premium' && !res.stripeConfig) {
            this.localStorageService.set('showFullScreenBilling', true);
          } else {
            this.localStorageService.remove('showFullScreenBilling');
          }

          if (
            res.phoneNumber &&
            !res.is_7_days_free_trial &&
            !this.excludeEmailsFromVerifyPhone.includes(email)
          ) {
            setTimeout(() => {
              document.body.classList.remove('organic_loading');
            }, 10);
            this.localStorageService.set('user-verify-phone', true);
            this.router.navigate(['verify-phone']);
          } else if (!res.phoneNumber && res.is_7_days_free_trial) {
            // setTimeout(() => {
            //   document.body.classList.remove('organic_loading');
            // }, 10);
            // this.router.navigate(['verify-number']);
          } else if (
            this.localStorageService.get('organic_signup_premium') &&
            this.localStorageService.get('seoSubscription') != 'Premium' &&
            email != 'master@behamics.com'
          ) {
            this.router.navigate(['/seo/billing']);
          }

          if (res.userPrivilegesTest) {
            this.allUserTargetPrivileges = res.userPrivilegesTest;
          } else {
            this.allUserTargetPrivileges = res.privileges;
          }

          const selectedTarget =
            this.coreTargetService.getSelectedTarget('target');

          this.localStorageService.set(
            'allUserTargetPrivileges',
            this.allUserTargetPrivileges,
          );

          let privileges = this.allUserTargetPrivileges.find((user: any) => {
            return user.shopID === selectedTarget;
          })?.priv;

          if (
            !this.allUserTargetPrivileges ||
            this.allUserTargetPrivileges?.length == 0
          ) {
            privileges = res['privileges'];
          } else if (!privileges || privileges?.length == 0) {
            privileges = this.allUserTargetPrivileges?.[0]?.priv;
          }

          this.localStorageService.set('privileges', privileges);

          const shopID = (res.shopID || [])?.find((target: any) => {
            return target.target === selectedTarget;
          });

          try {
            if (shopID) {
              this.appState.learningMode.set(shopID?.learningPhase || false);
              this.appState.autoActivate.set(shopID?.autoActivate || false);
              this.appState.behamicsDeactivated.set(
                shopID?.deactivated || false,
              );
              this.appState.isShopifyTarget.set(
                shopID?.isShopifyTarget || false,
              );
            }
          } catch (e) {}

          this.updateSidenavLinks();
        },
        error: (e) => {
          document.body.style.opacity = '1';
          this.authService.logout();
        },
      }),
    );
  }

  updateCurrencySymbol() {
    const currency = this.currencyService.getSelectedCurrency();

    switch (currency) {
      case 'EUR':
        return this.localStorageService.set('kpiSymbol', "#,###'€'");
      case 'USD':
        return this.localStorageService.set('kpiSymbol', "'$'#,###");
      case 'CHF':
        return this.localStorageService.set('kpiSymbol', "#,###'CHF'");
      case 'GBP':
        return this.localStorageService.set('kpiSymbol', "'£'#,###");
      case 'CZK':
        return this.localStorageService.set('kpiSymbol', "'kc'#,###");
      case 'PLN':
        return this.localStorageService.set('kpiSymbol', "'zl'#,###");
      case 'SEK':
        return this.localStorageService.set('kpiSymbol', "#,###'kr'");
      case 'JPY':
        return this.localStorageService.set('kpiSymbol', "'¥'#,###");
    }
  }

  refreshTargetList(targetDeleted: boolean = false) {
    this.clientList = [];
    this.liveClientList = [];
    this.notLiveClientList = [];
    this.workspacesClients = [];
    this.clientListFiltered = [];
    this.subs.add(
      this.targetList.getTargetList().subscribe((list) => {
        this.clientList = list;
        this.constructClientSelector('');

        let filteredList: any[];
        filteredList = this.clientList.filter(
          (o: any) => o.description == this.selectedStore,
        );

        this.currencyService.setSelectedCurrency(filteredList[0]?.currency);

        const selectedTarget = sessionStorage.getItem('selectedTargetTmp');
        if (selectedTarget) {
          this.selectedStore = selectedTarget;
          this.targetChange();
        }
        sessionStorage.removeItem('selectedTargetTmp');

        if (targetDeleted) {
          if (this.clientList.length == 0) {
            this.logout();
            return;
          }
          const firstStore =
            this.liveClientList[0] ||
            this.notLiveClientList[0] ||
            this.clientList[0];
          this.selectedStore = firstStore.description;

          this.targetChange();

          this.sidenavService.setIsTargetLoading(false);
        }
      }),
    );
  }

  getStartDate(event: any) {
    this.selectedRangeValue = 'custom';
    this.startDate = new Date(event.value);
    this.minDate = this.startDate;

    // Send Date Values
    this.updateLocalStorageDates();

    this.localStorageService.set('rangeValue', this.selectedRangeValue);

    let filteredList: any[];
    filteredList = this.clientList.filter(
      (o: any) => o.description == this.selectedStore,
    );
    this.selectionService.selectedStore(filteredList[0]?.description);
  }

  getEndDate(event: any) {
    this.selectedRangeValue = 'custom';

    const nowDate = new Date();
    const date = new Date(event.value);
    this.maxDate = date;

    if (
      date.getFullYear() == nowDate.getFullYear() &&
      date.getMonth() == nowDate.getMonth() &&
      date.getDate() == nowDate.getDate()
    ) {
      date.setHours(nowDate.getHours(), 59, 59);
    } else {
      date.setHours(23, 59, 59);
    }
    this.endDate = new Date(date);

    // Send Date Values
    this.updateLocalStorageDates();

    this.localStorageService.set('rangeValue', this.selectedRangeValue);

    let filteredList: any[];
    filteredList = this.clientList.filter(
      (o: any) => o.description == this.selectedStore,
    );
    this.selectionService.selectedStore(filteredList[0]?.description);
  }

  openDateRangeDialog(button: any, isCompare: boolean = false) {
    const rect = button.getBoundingClientRect();
    const isMobile = window.innerWidth < 841;
    const mobileDialogBounds = isMobile
      ? this.getMobileDateRangeDialogBounds(rect)
      : null;

    const top = `${mobileDialogBounds?.top ?? rect.bottom + window.scrollY}px`;
    const left = isMobile ? '85px' : '';
    const right = isMobile ? '' : `${window.innerWidth - rect.right}px`;

    let dataParams;
    if (isCompare) {
      dataParams = {
        startDate: this.compareStartDate,
        endDate: this.compareEndDate,
      };
    } else {
      dataParams = {
        startDate: this.startDate,
        endDate: this.endDate,
      };
    }

    this.dialog
      .open(DateRangePickerComponent, {
        backdropClass: 'no-backdrop',
        hasBackdrop: true,
        // disableClose: true,
        panelClass: 'date-range-popover',
        autoFocus: false,
        restoreFocus: false,
        maxHeight: mobileDialogBounds?.maxHeight,
        position: {
          top,
          left,
          right,
        },
        data: {
          ...dataParams,
          nudgeSplit: this.hasNudgePeriodSplit,
          target: this.coreTargetService.getSelectedTarget('target'),
          comparisonPeriodStart: isCompare ? this.startDate : null,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (!result) return;

        if (isCompare) {
          this.compareStartDate = result.startDate;
          this.compareEndDate = result.endDate;
          this.compareDates();
          return;
        }

        this.selectedRangeValue = 'custom';
        this.startDate = result.startDate;
        this.minDate = this.startDate;

        const nowDate = new Date();
        const date = result.endDate;
        this.maxDate = date;

        if (
          date.getFullYear() == nowDate.getFullYear() &&
          date.getMonth() == nowDate.getMonth() &&
          date.getDate() == nowDate.getDate()
        ) {
          date.setHours(nowDate.getHours(), 59, 59);
        } else {
          date.setHours(23, 59, 59);
        }
        this.endDate = new Date(date);

        // Send Date Values
        this.updateLocalStorageDates();

        this.localStorageService.set('rangeValue', this.selectedRangeValue);

        let filteredList: any[];
        filteredList = this.clientList.filter(
          (o: any) => o.description == this.selectedStore,
        );
        this.selectionService.selectedStore(filteredList[0]?.description);
      });
  }

  private getMobileDateRangeDialogBounds(rect: DOMRect): {
    top: number;
    maxHeight: string;
  } {
    const visualViewport = window.visualViewport;
    const viewportTop = visualViewport
      ? visualViewport.pageTop
      : window.scrollY;
    const viewportBottom = visualViewport
      ? visualViewport.pageTop + visualViewport.height
      : window.scrollY + window.innerHeight;
    const viewportPadding = 16;
    const defaultTop = rect.bottom + window.scrollY;
    const minimumUsableHeight = 280;
    let top = defaultTop;
    let availableHeight = viewportBottom - top - viewportPadding;

    if (availableHeight < minimumUsableHeight) {
      top = Math.max(
        viewportTop + viewportPadding,
        viewportBottom - viewportPadding - minimumUsableHeight,
      );
      availableHeight = viewportBottom - top - viewportPadding;
    }

    return {
      top,
      maxHeight: `${Math.max(0, Math.floor(availableHeight))}px`,
    };
  }

  rangeChanged(event: any) {
    let stoday = new Date();
    let etoday = new Date();

    if (this.selectedRangeValue == 'today') {
      stoday.setHours(0, 0, 0);
      this.startDate = stoday;
      this.minDate = stoday;

      etoday.setHours(etoday.getHours(), 59, 59);
      this.endDate = etoday;
      this.maxDate = etoday;
    } else if (this.selectedRangeValue == 'yestarday') {
      stoday.setDate(stoday.getDate() - 1);
      stoday.setHours(0, 0, 0);
      this.startDate = stoday;

      etoday.setDate(etoday.getDate() - 1);
      etoday.setHours(23, 59, 59);
      this.endDate = etoday;
      this.maxDate = etoday;
    } else if (this.selectedRangeValue == 'thisweek') {
      const d = new Date();
      const day = d.getDay();
      const diff = d.getDate() - day + (day == 0 ? -6 : 1);
      stoday = new Date(d.setDate(diff));

      stoday.setHours(0, 0, 0);
      this.startDate = stoday;
      this.minDate = stoday;

      etoday.setHours(etoday.getHours(), 59, 59);
      this.endDate = etoday;
      this.maxDate = etoday;
    } else if (this.selectedRangeValue == 'last7days') {
      stoday.setDate(stoday.getDate() - 7);
      stoday.setHours(0, 0, 0);
      this.startDate = stoday;
      this.minDate = stoday;

      etoday.setHours(etoday.getHours(), 59, 59);
      this.endDate = etoday;
      this.maxDate = etoday;
    } else if (this.selectedRangeValue == 'last30days') {
      stoday.setDate(stoday.getDate() - 30);
      stoday.setHours(0, 0, 0);
      this.startDate = stoday;
      this.minDate = stoday;

      etoday.setHours(etoday.getHours(), 59, 59);
      this.endDate = etoday;
      this.maxDate = etoday;
    } else if (this.selectedRangeValue == 'thismonth') {
      const tmpToday = new Date();
      const monthStartDate = new Date(
        tmpToday.getFullYear(),
        tmpToday.getMonth(),
        1,
      );

      this.startDate = monthStartDate;
      this.minDate = monthStartDate;

      etoday.setHours(etoday.getHours(), 59, 59);
      this.endDate = etoday;
      this.maxDate = etoday;
    } else if (this.selectedRangeValue == 'lastmonth') {
      const today = new Date();

      const previousMonth = today.getMonth() - 1;
      const year =
        previousMonth < 0 ? today.getFullYear() - 1 : today.getFullYear();
      const month = previousMonth < 0 ? 11 : previousMonth;

      const startOfLastMonth = new Date(year, month, 1, 0, 0, 0);

      const endOfLastMonth = new Date(year, month + 1, 0, 23, 59, 59);

      this.startDate = startOfLastMonth;
      this.minDate = startOfLastMonth;
      this.endDate = endOfLastMonth;
      this.maxDate = endOfLastMonth;
    } else if (this.selectedRangeValue == 'thisyear') {
      var thisyear = new Date(new Date().getFullYear(), 0, 1);

      this.startDate = thisyear;
      this.minDate = thisyear;

      etoday.setHours(etoday.getHours(), 59, 59);
      this.endDate = etoday;
      this.maxDate = etoday;
    }

    if (
      this.selectedRangeValue == 'today' ||
      this.selectedRangeValue == 'yesterday'
    ) {
      this.rate = 'hourly';
    }

    // Send Date Values
    this.updateLocalStorageDates();

    this.localStorageService.set('rangeValue', this.selectedRangeValue);

    let filteredList: any[];
    filteredList = this.clientList.filter(
      (o: any) => o.description == this.selectedStore,
    );
    this.selectionService.selectedStore(filteredList[0]?.description);
  }

  private toTimezoneBoundaryIso(
    date: Date,
    timezone: string,
    boundary: 'start' | 'end',
  ): string {
    const local = moment(date);
    const year = local.year();
    const month = local.month();
    const day = local.date();

    let m = moment.tz({ year, month, day }, timezone);

    if (boundary === 'start') {
      m = m.startOf('day');
    } else {
      const nowInTz = moment.tz(timezone);
      if (m.isSame(nowInTz, 'day')) {
        m = nowInTz.minutes(59).seconds(59);
      } else {
        m = m.endOf('day');
      }
    }

    return m.toDate().toISOString();
  }

  updateLocalStorageDates() {
    if (this.localStorageService.get('reuseDates')) return;

    if (this.hasNudgePeriodSplit && this.startDate && this.endDate) {
      const constrainedEnd = constrainNudgeRange(
        this.startDate, this.endDate, this.coreTargetService.getSelectedTarget('target'),
      );
      if (constrainedEnd !== this.endDate) {
        this.endDate = constrainedEnd;
        this.maxDate = constrainedEnd;
        this.selectedRangeValue = 'custom';
        this.localStorageService.set('rangeValue', 'custom');
      }
    }

    const timezone = this.timezoneService.getTimezone();

    if (this.startDate && this.endDate) {
      const startIso = this.toTimezoneBoundaryIso(
        this.startDate,
        timezone,
        'start',
      );
      const endIso = this.toTimezoneBoundaryIso(this.endDate, timezone, 'end');

      this.localStorageService.set('startDate', `${startIso}@${timezone}`);
      this.localStorageService.set('endDate', `${endIso}@${timezone}`);
    }
  }

  parentClientClick() {
    this.subTriggerModelAutomation = false;
    this.subTriggerClientResults = false;
    this.subTriggerAutomationScript = false;
    this.subTriggerPerformance = false;
    this.subTriggerSEO = false;

    this.subTriggerInvoices = !this.subTriggerInvoices;
    this.router.navigateByUrl('/invoices/list');
  }

  parentAutomationScriptClick() {
    this.subTriggerInvoices = false;
    this.subTriggerClientResults = false;
    this.subTriggerPerformance = false;
    this.subTriggerSEO = false;
    this.subTriggerAutomationScript = !this.subTriggerAutomationScript;
  }

  parentAdsClick() {
    this.subTriggerModelAutomation = false;
    this.subTriggerSEO = false;

    this.navigationLinksFiltered.forEach((link: any) => {
      if (link.title == 'Ad Copilot') {
        link.active = !link.active;

        if (link.active && !this.router.url.includes('/ads/')) {
          this.router.navigateByUrl('/ads/getting-started');
          // this.router.navigateByUrl('/ads/ai-audit');
        }
      } else {
        link.active = false;
      }
    });
  }

  parentBacklinkFreelancerClick() {
    this.subTriggerModelAutomation = false;
    this.subTriggerSEO = false;

    this.navigationLinksFiltered.forEach((link: any) => {
      if (link.title == 'Backlink Freelancer') {
        link.active = !link.active;

        if (
          link.active &&
          !this.router.url.includes('/seo/backlinks-overview')
        ) {
          this.router.navigateByUrl('/seo/backlinks-overview');
        }
      } else {
        link.active = false;
      }
    });
  }

  parentSEOClick() {
    this.subTriggerModelAutomation = false;

    if (
      (!this.isOpened && this.mobileQuery.matches) ||
      (this.router.url.includes('/seo/') &&
        !this.router.url.includes('/seo/billing'))
    ) {
      const link = this.navigationLinksFiltered.find(
        (link: any) => link.title == 'Organic',
      );
      link.active = !link.active;

      return;
    }

    for (let i = 0; i < this.navigationLinksFiltered.length; i++) {
      if (this.navigationLinksFiltered[i].title == 'Organic') {
        this.navigationLinksFiltered[i].active =
          !this.navigationLinksFiltered[i].active;
      } else {
        this.navigationLinksFiltered[i].active = false;
      }
    }

    if (
      this.localStorageService.get('organic_signup_premium') &&
      this.localStorageService.get('seoSubscription') != 'Premium' &&
      this.localStorageService.get('email') != 'master@behamics.com'
    ) {
      this.router.navigate(['/seo/billing']);
    } else {
      this.router.navigateByUrl('/seo/getting-started');
    }
  }
  redirectToOrganic() {
    if (this.seoOnlyLinks) {
      if (
        this.localStorageService.get('organic_signup_premium') &&
        this.localStorageService.get('seoSubscription') != 'Premium' &&
        this.localStorageService.get('email') != 'master@behamics.com'
      ) {
        this.router.navigate(['/seo/billing']);
      } else {
        this.router.navigateByUrl('/seo/getting-started');
      }
    }
  }
  closeParentTrigger() {
    this.subTriggerModelAutomation = false;
    for (let i = 0; i < this.navigationLinksFiltered.length; i++) {
      this.navigationLinksFiltered[i].active = false;
    }
  }
  parentModelsClick() {
    this.subTriggerModelAutomation = !this.subTriggerModelAutomation;
  }

  showNonLive = false;

  toggleNonLive() {
    this.showNonLive = !this.showNonLive;
  }

  showWorkspaces = false;

  toggleWorkspaces() {
    this.showWorkspaces = !this.showWorkspaces;
  }

  upgradeKeywordPlan() {
    this.router.navigate(['/seo/billing']);
  }

  openKeywordLimitModal() {
    this.keywordLimitDialogRef = this.dialog.open(KeywordLimitComponent, {
      width: '680px',
      maxWidth: '90vw',
      data: {
        keywordsLeft: this.keywordsLeft,
        projectName: this.selectedSeoProject?.domain || 'your project',
      },
      disableClose: false,
      panelClass: 'keyword-limit-modal-panel',
    });

    this.keywordLimitDialogRef.afterClosed().subscribe((result) => {
      if (result === 'upgrade') {
        this.router.navigate(['/seo/billing']);
      }
    });
  }

  formatComma(value: any) {
    return value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Handle actual selection changes
  onSelectionChange(event: any) {
    // Only execute targetChange if a valid option is selected
    if (event.value && event.value !== 'nonLiveGroup') {
      this.selectedStore = event.value; // Update the selected store
      this.targetChange(); // Call your targetChange function
    }
  }

  targetChange() {
    let filteredList: any[] = this.clientList.filter(
      (o: any) => o.description == this.selectedStore,
    );

    try {
      this.appState.targetUrl.set(filteredList[0]?.url || '');
    } catch (e) {}

    try {
      this.appState.learningMode.set(filteredList[0]?.learningPhase || false);
      this.appState.autoActivate.set(filteredList[0]?.autoActivate || false);
      this.appState.behamicsDeactivated.set(
        filteredList[0]?.deactivated || false,
      );
      this.appState.isShopifyTarget.set(
        filteredList[0]?.isShopifyTarget || false,
      );
    } catch (e) {}

    const gcr = filteredList?.[0]?.value || 0;
    this.sidenavService.globalControlRate.set(gcr);

    try {
      let role: string = this.localStorageService.get('role') || '';
      if (role == 'master') {
        this.seoSubscription = 'Premium';
      } else {
        const seoSub =
          this.seoSubscriptionList?.find((sub: any) => {
            return sub.shopID == filteredList[0].target;
          })?.seoSubscription || 'Freemium';

        this.seoSubscription = seoSub || 'Freemium';
      }

      this.localStorageService.set('seoSubscription', this.seoSubscription);
    } catch (e) {
      console.log(e);
    }

    if (
      this.localStorageService.get('organic_signup_premium') &&
      this.localStorageService.get('seoSubscription') != 'Premium' &&
      this.localStorageService.get('email') != 'master@behamics.com'
    ) {
      this.router.navigate(['/seo/billing']);
    }

    this.gaStatus = filteredList[0]?.ga4;

    if (filteredList[0].region == 'central-us') {
      this.sessionStorageService.set('region', 'central-us');
    } else {
      this.sessionStorageService.set('region', 'west-eu');
    }

    this.isTargetWithOverallSwitcher = filteredList[0].overallView || false;

    this.showOverallSwitcher =
      (this.isTargetWithOverallSwitcher &&
        !this.showGonserOverallSwitcher &&
        this.router.url.includes('/master-preview')) ||
      false;

    this.coreTargetService.setSelectedTarget('target', filteredList[0].target);
    this.coreTargetService.setSelectedTarget('name', this.selectedStore);

    this.currencyService.setSelectedCurrency(filteredList[0].currency);

    let privileges = this.allUserTargetPrivileges.find((user: any) => {
      return user.shopID === filteredList[0].target;
    })?.priv;

    if (!privileges || privileges.length == 0) {
      privileges = this.allUserTargetPrivileges?.[0]?.priv;
    }

    this.localStorageService.set('privileges', privileges);

    // Nudge Lite Detector
    this.localStorageService.set('nudgeLite', filteredList[0]?.value == 0.01);

    this.isTargetNudgelite = filteredList[0]?.value == 0.01;
    this.nudgeLiteToggle = filteredList[0]?.value == 0.01;

    if (this.nudgeLiteToggle) {
      this.nudgeLiteToggleTheme = 'on';
    } else {
      this.nudgeLiteToggleTheme = 'off';
    }

    if (this.hasNudgePeriodSplit) this.updateLocalStorageDates();
    this.selectionService.selectedStore(filteredList[0]?.description);

    // Get path depending on privilege
    const privilegeRoute = this.authService.routesWithPrivileges.find(
      (route: any) => privileges.includes(route.privileges),
    )?.path;

    // Check if you have privileges for current path
    const currentPathPrivilege = this.authService.routesWithPrivileges.find(
      (route: any) => window.location.pathname.includes(route.path),
    )?.privileges;

    // Check if user has privilege for current path
    if (
      !privileges.includes(currentPathPrivilege) &&
      (privilegeRoute || privilegeRoute != '')
    ) {
      // if user doesn't have privilege then get the first path that
      // match with user privileges and redirect to it
      this.router.navigate([privilegeRoute]);
    }

    this.updateLocalStorageDates();

    if (
      this.router.url.includes('/seo/') &&
      !this.router.url.includes('/seo/billing')
    ) {
      this.getSeoProjectsFunc(true);
    }

    this.sidenavService.getAdsProjectsFunc();

    this.updateCurrencySymbol();
    this.updateSidenavLinks();
    this.getGSCIntegrationStatus();
  }

  updateProjectStatus() {
    this.subs.add(
      this.seoService.getProjects().subscribe({
        next: (response) => {
          if (response) {
            this.seoProjects = response;

            this.seoProjects = this.seoProjects.sort((a: any, b: any) => {
              if (a?.domain < b?.domain) {
                return -1;
              }
              if (a?.domain > b?.domain) {
                return 1;
              }
              return 0;
            });

            this.seoProjectsFiltered = [...this.seoProjects];

            let parsedSessionProject: any;
            try {
              if (
                sessionStorage.getItem('selectedProject') &&
                sessionStorage.getItem('selectedProject')?.trim() !==
                  'undefined'
              ) {
                parsedSessionProject = JSON.parse(
                  sessionStorage.getItem('selectedProject') || '{}',
                );
              } else {
                parsedSessionProject = {};
              }
            } catch (e) {
              console.log(e);
            }

            const pagesSeoUrl = sessionStorage.getItem('pages_seo_url');

            if (pagesSeoUrl) {
              this.selectedSeoProject = this.seoProjects.find((p: any) =>
                pagesSeoUrl.includes(p['domain']),
              );

              sessionStorage.removeItem('pages_seo_url');
            } else if (Object.keys(parsedSessionProject).length > 0) {
              this.selectedSeoProject = this.seoProjects.find((p: any) =>
                parsedSessionProject['domain']?.includes(p['domain']),
              );

              if (!this.selectedSeoProject) {
                this.selectedSeoProject = this.seoProjects[0];
              }
            } else {
              this.selectedSeoProject = this.seoProjects[0];
            }

            this.selectedSeoProjectURL = this.selectedSeoProject?.url;

            if (this.selectedSeoProject) {
              this.sidenavService.setSeoProject(this.selectedSeoProject);
            } else {
              this.sidenavService.setSeoProject('');
            }

            this.subs.add(
              this.sidenavService.childData$().subscribe((data: any) => {
                if (data.url) {
                  this.selectedSeoProjectURL = data.url;
                } else if (this.selectedSeoProject) {
                  this.selectedSeoProjectURL = this.selectedSeoProject.url;
                }
                this.seoProjectChanged();
              }),
            );
          }
        },
        error: (error) => {
          console.error(error);
        },
      }),
    );
  }

  logout() {
    this.authService.logout();
  }

  toggleSidenavSize() {
    this.isOpened = !this.isOpened;
  }

  productTourEnabled: boolean = false;
  toggleProductTour() {
    this.productTourEnabled = !this.productTourEnabled;
  }

  productTourLoading: boolean = false;
  triggerProductTour() {
    let tourId: number = 0;

    const domElement = document.querySelector('[behamicsProductTourID]');
    if (domElement) {
      tourId = parseInt(
        domElement.getAttribute('behamicsProductTourID') || '0',
      );
    }

    this.productTourLoading = true;
    if (tourId != 0) {
      this.intercomService.startTour(tourId);
      // Intercom('startTour', tourId);

      const getSeenTour = this.localStorageService.get('seenTours') || {};
      this.localStorageService.set('seenTours', {
        ...getSeenTour,
        [tourId]: true,
      });

      setTimeout(() => {
        this.productTourLoading = false;
      }, 600);
    } else {
      this.productTourLoading = false;
    }
  }
  openProductTour() {
    // if (this.seoStillLoadingBlock) return;
    // requestAnimationFrame(() => {
    //   const tourID =
    //     document
    //       .querySelector('[behamicsProductTourID]')
    //       ?.getAttribute('behamicsProductTourID') || '0';
    //   const getSeenTour: any = this.localStorageService.get('seenTours') || {};
    //   if (!getSeenTour[tourID] || Object.keys(getSeenTour).length == 0) {
    //     this.triggerProductTour();
    //   }
    // });
  }
  changeLanguage(lang: string) {
    this.savedLang = lang;
    this.currentLang = lang;
    this.translate.use(lang);
    this.localStorageService.set('language', lang);

    location.reload();
  }
  updateGonserOverallSwitcher() {
    this.gonserOverallSwitcher = !this.gonserOverallSwitcher;

    if (!this.gonserOverallSwitcher) {
      this.localStorageService.remove('gonserOverallSwitcher');
    } else {
      this.localStorageService.set('gonserOverallSwitcher', true);
    }

    const selectedName = this.coreTargetService.getSelectedTarget('name');
    this.selectionService.selectedStore(selectedName);
  }

  updateOverallSwitcher() {
    this.overallSwitcher = !this.overallSwitcher;

    if (!this.overallSwitcher) {
      this.localStorageService.remove('nudgeOverallSwitcher');
    } else {
      this.localStorageService.set('nudgeOverallSwitcher', true);
    }

    const selectedName = this.coreTargetService.getSelectedTarget('name');
    this.selectionService.selectedStore(selectedName);
  }

  private navResizeObserver?: ResizeObserver;

  adaptNavigationListHeight(): void {
    const container = document.querySelector(
      '.master-admin-nav',
    ) as HTMLElement;
    if (!container) return;

    this.navResizeObserver?.disconnect();

    this.navResizeObserver = new ResizeObserver(() => {
      try {
        const lists = container.querySelectorAll(
          'mat-nav-list',
        ) as NodeListOf<HTMLElement>;
        if (lists.length < 2) return;

        const firstList = lists.item(0);
        const secondList = lists.item(1);

        if (!firstList || !secondList) return;

        const availableHeight = Math.max(
          300,
          container.clientHeight - secondList.offsetHeight - 30,
        );

        firstList.style.maxHeight = `${availableHeight}px`;
      } catch (e) {
        console.log(e);
        return;
      }
    });

    this.navResizeObserver.observe(container);
  }

  redirectToIntegrations() {
    this.router.navigate(['/seo/integrations']);
  }
  extensionButtonClicked() {
    window.open(
      'https://chromewebstore.google.com/detail/ads-copilot/ccmdjghjdgnacbakhbpacafkpehlpajg',
      '_blank',
    );
  }

  isDaylightSavingTime() {
    try {
      const now = new Date();

      this.timezoneList = this.timezoneList.map((tz: any) => {
        try {
          const zone = (moment as any).tz.zone(tz.name);
          if (!zone) return tz;
          const minutes = (moment as any).tz(now, tz.name).utcOffset();
          const offsetHours = minutes / 60;
          return { ...tz, offset: offsetHours };
        } catch {
          return tz;
        }
      });

      const savedTz = this.timezoneService.getTimezone?.() || '';
      const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      const preferredTz = savedTz || browserTz || 'Europe/Berlin';
      this.selectedTimezone = preferredTz;

      if (!this.timezoneList.some((t: any) => t.name === preferredTz)) {
        try {
          const minutes = (moment as any).tz(now, preferredTz).utcOffset();
          this.timezoneList.push({ name: preferredTz, offset: minutes / 60 });
        } catch {}
      }

      this.timezoneList = this.timezoneList
        .slice()
        .sort(
          (a: any, b: any) =>
            a.offset - b.offset || String(a.name).localeCompare(String(b.name)),
        );
    } catch (e) {
      console.log(e);
    }
  }
  setSelectedTimezone(): void {
    try {
      const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      let localOffset = moment.tz(localTimezone).utcOffset() / 60;
      for (let i = 0; i < this.timezoneList.length; i++) {
        if (parseFloat(this.timezoneList[i].offset) === localOffset) {
          this.timezoneList[i]['local_timezone'] = true;

          if (!sessionStorage.getItem('selectedTimezone')) {
            this.timezoneService.setTimezone(this.timezoneList[i].name);
          }
          break;
        }
      }

      this.hideTimezoneSelection = false;
    } catch (e) {
      this.hideTimezoneSelection = true;
      console.log(e);
    }
  }

  timezoneChanged() {
    this.timezoneService.setTimezone(this.selectedTimezone);
    location.reload();
  }

  public meetingsDialogRef: MatDialogRef<MeetingsPopupComponent>;
  sevenDaysFreeTrial() {
    this.meetingsDialogRef = this.dialog.open(MeetingsPopupComponent, {
      width: '900px',
      data: {
        header: "Don't Miss Out After Your Trial",
        description:
          'Book a meeting with our expert to receive your exclusive offer for the<br/><strong>Premium Subscription</strong> and keep unlocking powerful AI insights.',
      },
    });
  }

  freeTrialExpiredBool: boolean = false;
  freeTrialExpired() {
    this.freeTrialExpiredBool = true;

    this.overlayContainer.getContainerElement();

    // avoid opening twice
    if (this.meetingsDialogRef && this.meetingsDialogRef.getState() !== 0) {
      return;
    }

    this.meetingsDialogRef = this.dialog.open(MeetingsPopupComponent, {
      width: '900px',
      disableClose: true,
      data: {
        header: 'Free Trial Expired',
        description:
          'Book a meeting with our expert to receive your exclusive offer for the<br/><strong>Premium Subscription</strong> and keep unlocking powerful AI insights.',
        noCloseButton: true,
      },
    });
  }
  invoiceStatusChanged(status: string): void {
    const invoiceTotalsObj = this.sidenavService.getInvoiceTotalsObj() || {};
    this.sidenavService.setInvoiceTotals({
      ...invoiceTotalsObj,
      status: status,
    });
  }

  hideFirstPartOfString(str: string): string {
    const withoutFirstPart = str
      .split(' ')
      ?.slice(1)
      ?.join(' ')
      ?.replace('Weber', '');
    if (!withoutFirstPart) return '******';
    return `****** ${withoutFirstPart}`;
  }

  nudgeLiteToggleTheme: string = 'off';
  get hasNudgePeriodSplit(): boolean {
    return hasNudgeSplit(this.coreTargetService.getSelectedTarget('target'));
  }

  get nudgePeriodNoticeKey(): string {
    return hasVolvoNudgePeriods(this.coreTargetService.getSelectedTarget('target'))
      ? 'volvo_nudge_period_notice'
      : 'nudge_period_notice';
  }

  switchNudgeLiteModeTheme() {
    if (this.nudgeLiteToggleTheme == 'on') {
      this.nudgeLiteToggle = true;
    } else {
      this.nudgeLiteToggle = false;
    }
    this.localStorageService.set('nudgeLite', this.nudgeLiteToggle);
    this.selectionService.selectedStore(
      this.coreTargetService.getSelectedTarget('name'),
    );
  }
  switchNudgeLiteMode(event: any) {
    this.nudgeLiteToggle = event.checked;
    this.localStorageService.set('nudgeLite', this.nudgeLiteToggle);
    this.selectionService.selectedStore(
      this.coreTargetService.getSelectedTarget('name'),
    );
  }

  getSelectedRangeTranslateKey(): string {
    return (
      this.ranges.find((range) => range.value === this.selectedRangeValue)
        ?.translateKey || 'words.custom'
    );
  }

  getSelectedLanguageTranslateKey(): string {
    return (
      this.languages.find((lang) => lang.code === this.savedLang)?.label ||
      'words.english'
    );
  }

  getSelectedThemeTranslateKey(): string {
    return this.selectedTheme === 'dark'
      ? 'phrases.dark_mode'
      : 'phrases.light_mode';
  }

  public compareDates(updateDates: boolean = true) {
    if (!updateDates) {
      const previousPeriod = this.getPreviousPeriod(
        this.startDate,
        this.endDate,
      );
      this.compareStartDate = previousPeriod.startDate;
      this.compareEndDate = previousPeriod.endDate;
    } else {
      const nowDate = new Date();
      const date = new Date(this.compareEndDate);

      if (
        date.getFullYear() == nowDate.getFullYear() &&
        date.getMonth() == nowDate.getMonth() &&
        date.getDate() == nowDate.getDate()
      ) {
        date.setHours(nowDate.getHours(), 59, 59);
      } else {
        date.setHours(23, 59, 59);
      }

      this.compareEndDate = new Date(date);
    }

    this.compareMinDate = this.compareStartDate;
    this.compareMaxDate = this.compareEndDate;

    if (this.hasNudgePeriodSplit) {
      const period = getNudgePeriod(
        this.coreTargetService.getSelectedTarget('target'), this.startDate,
      );
      if (period.end) {
        this.compareEndDate = new Date(
          Math.min(this.compareEndDate.getTime(), period.end.getTime()),
        );
      }
      if (period.start) {
        this.compareStartDate = new Date(
          Math.max(this.compareStartDate.getTime(), period.start.getTime()),
        );
      }

      // A comparison from the other group split has different metric semantics.
      if (this.compareStartDate > this.compareEndDate) {
        this.isCompareDatesActive = false;
      }
      this.compareMinDate = this.compareStartDate;
      this.compareMaxDate = this.compareEndDate;
    }

    const timezone = this.timezoneService.getTimezone();
    this.sidenavService.setCompareDates({
      startDate: this.hasNudgePeriodSplit
        ? new Date(this.toTimezoneBoundaryIso(this.compareStartDate, timezone, 'start'))
        : this.compareStartDate,
      endDate: this.hasNudgePeriodSplit
        ? new Date(this.toTimezoneBoundaryIso(this.compareEndDate, timezone, 'end'))
        : this.compareEndDate,
      isActive: this.isCompareDatesActive,
    });
  }

  private showCompareDatesContainerFunc() {
    this.showCompareDatesContainer =
      this.selectedTab == 0 && this.router.url.includes('/master-preview');
  }

  getPreviousPeriod(startDate: Date, endDate: Date) {
    const MS_IN_DAY = 24 * 60 * 60 * 1000;

    const today = new Date();
    const isEndDateToday = endDate.toDateString() === today.toDateString();

    // Normalize startDate → 00:00:00
    const normalizedStart = new Date(startDate);
    normalizedStart.setHours(0, 0, 0, 0);

    // Normalize endDate
    const normalizedEnd = new Date(endDate);
    if (isEndDateToday) {
      normalizedEnd.setHours(
        today.getHours(),
        today.getMinutes(),
        today.getSeconds(),
        0,
      );
    } else {
      normalizedEnd.setHours(23, 59, 59, 0);
    }

    // Calculate number of days in the period (inclusive)
    const daysInPeriod =
      Math.floor(
        (normalizedEnd.getTime() - normalizedStart.getTime()) / MS_IN_DAY,
      ) + 1;

    // Previous period end = day before current start
    const previousEnd = new Date(normalizedStart.getTime() - 1);
    previousEnd.setHours(23, 59, 59, 0);

    // Previous period start
    const previousStart = new Date(
      previousEnd.getTime() - (daysInPeriod - 1) * MS_IN_DAY,
    );
    previousStart.setHours(0, 0, 0, 0);

    return {
      startDate: previousStart,
      endDate: previousEnd,
    };
  }

  get canShowInvoices(): boolean {
    return (
      this.checkRoleGuard('masterInvoices') ||
      this.checkRoleGuard('masterInvoicesConfiguration')
    );
  }

  public shareAuditDialogRef: MatDialogRef<ShareAuditComponent>;
  public shareWebsiteAudit() {
    this.shareAuditDialogRef = this.dialog.open(ShareAuditComponent, {
      width: '430px',
      data: {},
    });

    this.subs.add(
      this.shareAuditDialogRef.afterClosed().subscribe((email: string) => {
        if (!email) {
          return;
        }

        this.createWebsiteAuditShareLink(email);
      }),
    );
  }

  private createWebsiteAuditShareLink(email: string) {
    this.subs.add(
      this.websiteAuditService
        .getAuditTaskShareableToken({
          taskId: this.selectedWebsiteAuditProjectId,
          email: encodeURIComponent(email),
          // Stamp the sharer's theme so the public page opens in the same
          // dark/light mode. It's stored with the share record and comes back
          // from the short-link lookup, so it stays out of the link itself.
          theme: this.darkMode ? 'dark' : 'light',
        })
        .subscribe({
          next: (res: any) => {
            // res.token is the short code — /share/:shortUrl resolves it to the
            // audit token and redirects to the public audit page.
            navigator.clipboard.writeText(
              `${window.location.origin}/share/${res.token}`,
            );
            this.notificationService.info('Shareable url copied!');
          },
          error: (err: any) => {
            this.notificationService.error(err?.error?.message);
          },
        }),
    );
  }
  public downloadWebsiteAudit(): void {
    const taskId =
      this.selectedWebsiteAuditProjectId ||
      this.selectedWebsiteAuditTask?.parentTaskId ||
      this.selectedWebsiteAuditTask?.taskId;
    const competitorUrl =
      this.selectedWebsiteAuditTask?.selectedCompetitor?.url ||
      this.selectedWebsiteAuditTask?.selectedCompetitor?.competitorUrl ||
      this.selectedWebsiteAuditTask?.selectedCompetitor?.domain;

    if (!taskId) {
      this.notificationService.error(
        'The website audit report could not be downloaded.',
      );
      return;
    }

    this.websiteAuditDownloading = true;
    this.subs.add(
      this.websiteAuditService
        .downloadWebsiteAuditReport(taskId, competitorUrl)
        .subscribe({
          next: (report: Blob) => {
            const url = window.URL.createObjectURL(report);
            const link = document.createElement('a');
            const domain =
              this.getDomainFromUrl(this.selectedWebsiteAuditTask?.url) ||
              this.selectedWebsiteAuditProjectDomain ||
              'website';

            const competitor = competitorUrl
              ? ' - ' + this.getDomainFromUrl(competitorUrl)
              : '';

            link.href = url;
            link.download = `Website Audit of ${domain}${competitor}.json`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          },
          error: (err: any) => {
            this.notificationService.error(
              err?.error?.message ||
                'The website audit report could not be downloaded.',
            );
          },
          complete: () => {
            this.websiteAuditDownloading = false;
          },
        }),
    );
  }

  public displayVideo(isDemo: boolean = false): void {
    const url = this.router.url?.split('?')[0];
    const getVideoSrc = isDemo
      ? videoExplanationSrc[url]?.demo
      : videoExplanationSrc[url]?.[this.selectedTab];

    if (getVideoSrc) {
      const content = {
        src: isDemo ? getVideoSrc : getVideoSrc.src,
        html: '',
        label: isDemo ? 'Demo' : getVideoSrc.label,
        isHTML: false,
        showLabel: false,
        isVideo: true,
      };

      this.fullScreenPreviewService.setContent(content);
      this.fullScreenPreviewService.openPreview();
    }
  }

  public openPdfClicked(type: string): void {
    try {
      const url = this.router.url?.split('?')[0];

      const getSrc = url.includes('/seo/')
        ? organicPDFLink[type]
        : videoExplanationSrc[url][type];

      window.open(getSrc, '_blank');
    } catch (err) {
      console.log(err);
    }
  }

  private checkShowExplanationVideo(): void {
    const url = this.router.url?.split('?')[0];

    if (videoExplanationSrc[url]?.[this.selectedTab]) {
      this.showExplanationVideoBool = true;
    } else {
      this.showExplanationVideoBool = false;
    }
  }

  private onResize() {
    this.adaptNavigationListHeight();

    if (window.innerWidth < 840 && this.isCompareDatesActive) {
      this.isCompareDatesActive = false;
      this.compareDates();
    }
  }

  onStartDateChange(date: Date) {
    this.startDate = date;

    if (this.endDate && this.endDate < date) {
      this.endDate = date;
    }

    this.updateLocalStorageDates();
  }

  onEndDateChange(date: Date) {
    this.endDate = date;
    this.updateLocalStorageDates();
  }

  public isTextTruncated(element: HTMLElement): boolean {
    return element.scrollWidth > element.clientWidth;
  }

  public get showLanguageSelector(): boolean {
    const url = this.router.url?.split('?')[0];

    const pagesWithTranslations = [
      '/dashboard',
      '/master-preview',
      '/user-permissions',
      '/nudgeGPT',
      '/recording',
      '/merchandising',
      '/agents',
      '/signals',
    ];

    const diagnosticsPages = this.router.url?.includes('/diagnostic');
    const organicPages = this.router.url?.includes('/seo/');

    const excludePages = ['seo/billing'];

    return (
      (pagesWithTranslations.includes(url) ||
        diagnosticsPages ||
        organicPages) &&
      !excludePages.includes(url)
    );
  }

  public getLinksTooltip(link: any): string {
    const lowerCaseTitle: string = link?.title?.toLocaleLowerCase();

    if (lowerCaseTitle == '' || !link.shopifyDisabled) return '';

    switch (lowerCaseTitle) {
      case 'nudge':
        return `Nudge isn't live yet \nBehamics is in Learning Mode. Nudges unlock automatically once learning completes, about 1 day left.`;
      case 'signals':
        return `Signals isn't live yet \nBehamics is in Learning Mode. Signals unlock automatically once learning completes, about 1 day left.`;
      default:
        return '';
    }
  }
}
